<template>
  <div class="pipeline-mapping" id="pipeline-mapping" @contextmenu.prevent>
    <!-- 左侧工具栏 -->
    <div class="left-toolbar toolbar-common">
      <div class="tool-item" v-for="(tool, index) in leftTools" :key="index" @click="handleToolClick(tool)">
        <img :src="require(`@/assets/collect/${tool.icon}`)" :alt="tool.name" :title="tool.name">
      </div>
    </div>
    <!-- 中间工具栏 -->
    <toolbar-module v-show="!polygonShow" ref="toolbarModule" class="toolbar-common center-toolbar"
      :project-id.sync="currentProjectId" :current-base-map="currentBaseMap" :marker-prop-list="markerPropList"
      :line-prop-list="linePropList" :handle-layer-data="handleLayerData" :handle-layer-refresh="handleLayerRefresh"
      @basemap-change="handleBaseMapChange" @pipeline-tool-click="handlePipelineToolClick"
      @assist-tool-click="handleAssistToolClick" @filter-success="handleFilterSuccess" @show-layer-type="showLayerType"
      @item-selection="itemSelection" @import-gis="handleImportGIS" @refresh-map="anewloadProjectMap"
      @query-map-message="queryMapMssage" @close-filter-detail="closeFilterDetail" />

    <!-- 过滤详情弹窗 -->
    <div class="filter-detail-modal" v-if="filterDetailVisible">
      <div class="filter-detail-header">
        <span class="title">{{ filterType === 1 ? '管点' : '管线' }}过滤详情</span>
        <a-icon type="close" @click="closeFilterDetail" class="close-icon" />
      </div>
      <div class="filter-detail-content">
        <!-- 添加模板选择 -->
        <div class="template-select">
          <span class="label">模板选择：</span>
          <a-select v-model="selectedTemplateId" placeholder="请选择导出模板" style="width: 200px"
            @change="handleTemplateChange">
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">
              {{ item.templateName }}
            </a-select-option>
          </a-select>
          <a-button type="primary" :loading="exportLoading"
            :disabled="!selectedTemplateId || selectedDetailKeys.length === 0" @click="handleExportFilter"
            style="margin-left: 8px;">
            导出
          </a-button>
        </div>
        <a-table :columns="filterDetailColumns" :dataSource="filterDetailData"
          :rowSelection="{ selectedRowKeys: selectedDetailKeys, onChange: onDetailSelectChange }" :pagination="false"
          size="small" :scroll="{ y: 300 }">
          <template slot="serialNumber" slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
          <template slot="action" slot-scope="text, record">
            <a @click="handleViewDetailItem(record)">查看</a>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 右侧工具栏 -->
    <RightToolbarModule class="toolbar-common right-toolbar" :project-info="projectInfo"
      :type-list="Object.values(typeList)" :project-data="projectData" @update:projectData="handleProjectDataUpdate"
      :isLuminance="isLuminance" @update:isLuminance="isLuminanceUpdate" />

    <!-- 表单组件 -->
    <transition name="first">
      <FormModule v-if="formShow" class="module" style="z-index: 1001;" :style="polygonShow ? 'left: 580px;' : ''"
        @form-to-parent="formModule" :properties-object="formPropObject" :monitor-coordinate="formCoordinate"
        :get-connection-point="connectionMarker" :current-project-id="currentProjectId" :project-data="projectData"
        @on-line="formOnLine" />
    </transition>

    <!-- 查询组件 -->
    <transition name="first">
      <QueryModule v-if="queryShow" class="module" @qeury-to-parent="queryModule"
        :current-project-id="currentProjectId" />
    </transition>

    <!-- 多边框选组件 -->
    <transition name="first">
      <PolygonModule v-if="polygonShow" class="module" style="width: 550px;" @polygon-to-parent="polygonModule"
        :polygon-query-data="polygonQueryData" :polygon-query-refresh="polygonQueryRefresh" />
    </transition>

    <transition name="first">
      <CoordinateModule v-if="coordinateShow" class="module" @coordinate-to-parent="coordinateModule"
        :coordinate-editor-data="coordinateEditorData" :coordinate-data="coordinateData" />
    </transition>

    <!-- 地图容器 -->
    <div id="map" class="map" ref="mapContainer"></div>

    <!-- 遮罩层 -->
    <a-spin v-if="spinning" tip="加载项目中...">
      <div style=" background: #e6f7ff; height: 100%;"> </div>
    </a-spin>

    <ItemSelectionModule :item-selection-show="itemSelectionShow" @update:itemSelectionShow="itemSelectionShowUpdate"
      @toggle-to-parent="toggleProject">
    </ItemSelectionModule>

  </div>
</template>

<script>
import storage from 'store'
import { LonLat } from '@/store/mutation-types'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import Provider from '@/utils/chinatmsproviders.js'
import 'leaflet-polylinedecorator'
import 'leaflet-measure-path/leaflet-measure-path.css'
import 'leaflet-measure-path/leaflet-measure-path.js'
import 'leaflet-draw'
import "leaflet-draw/dist/leaflet.draw.css";
import "../../../public/leafletjs/leaflet.draw-cn"
import { CanvasMarkerLayer } from "leaflet.canvasmarker.csl"
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'

//js工具类
import { sortBasicInfoList, sortBasicInfoTree } from './pipe-line-mapping-module/js/projectInfo'

//组件导入
import FormModule from './pipe-line-mapping-module/FormModule.vue' //表单
import ToolbarModule from './pipe-line-mapping-module/ToolbarModule.vue'
import RightToolbarModule from './pipe-line-mapping-module/RightToolbarModule.vue'
import QueryModule from './pipe-line-mapping-module/QueryModule.vue' //查询
import PolygonModule from './pipe-line-mapping-module/PolygonModule.vue'
import CoordinateModule from './pipe-line-mapping-module/CoordinateModule.vue'
import ItemSelectionModule from './pipe-line-mapping-module/ItemSelectionModule.vue'

import { icon } from 'leaflet'

export default {
  name: 'PipelineMapping',
  components: {
    FormModule,
    ToolbarModule,
    RightToolbarModule,
    QueryModule,
    PolygonModule,
    CoordinateModule,
    ItemSelectionModule
  },
  data () {
    return {
      spinning: false, //加载遮罩层
      /**项目配置基础数据 */
      projectData: {}, //当前项目管类
      typeList: [], //项目管类列表
      currentProjectId: '', //从ToolbarModule获取 当前项目id
      projectInfo: {}, //项目详情
      /**请求接口区域 */
      /*PC端接口 */
      //url最后有 /的为后面有参数的GET请求
      queryBasicInfo: '/gis-manager/foundation/tube/basic/info', //查询管点，线配置列表
      queryTypeListUrl: '/gis-manager/foundation/tube/list',
      queryProjectUrl: '/gis-manager/diagramming/project/pipeline/page/', //通过项目id获取项目列表
      insertMarkerUrl: '/gis-manager/diagramming/point/add', //插入数据库
      deleteMarkerUrl: '/gis-manager/diagramming/point/remove/', //删除管点
      deleteLineUrl: '/gis-manager/diagramming/pipe/remove/', //删除管线
      updateMarkerUrl: '/gis-manager/diagramming/point/edits', //修改管点
      insertionMarkerUrl: '/gis-manager/diagramming/point/new/inserts', //插入管点
      updateLineUrl: '/gis-manager/diagramming/pipe/edits', //修改管线
      insertLineUrl: '/gis-manager/diagramming/pipe/adds', //新增管线
      moveMarkerUrl: '/gis-manager/diagramming/point/moving/pipe', //移动管点
      fillMarkerUrl: '/gis-manager/diagramming/point/edit/coordinates', //编辑管点坐标
      queryBoxSelectUrl: '/gis-manager/diagramming/project/multi/border', //框选查询管点 管线
      deleteBatchMarkerUrl: '/gis-manager/diagramming/point/batch/remove', //批量删除管点
      deleteBatchLineUrl: '/gis-manager/diagramming/pipe/batch/remove', //批量删除管线
      queryProjectInfoUrl: '/gis-manager/diagramming/project/get/', //获取项目信息
      /**组件对象区域 */
      /* 子页面组件属性 */
      /*表单 */
      formShow: false, //表单组件显示
      formPropObject: {}, //表单自定义属性对象
      formCoordinate: {}, //表单坐标对象
      /*查询 */
      queryShow: false, //查询组件显示
      /*多边形框选 */
      polygonShow: false, //多边框选组件显示
      polygonQueryData: {}, //多边框选组件查询对象
      polygonQueryRefresh: 0, //多边框查询重置
      /*坐标编辑 */
      coordinateShow: false, //管点坐标编辑对话框
      coordinateEditorData: {}, //管点坐标编辑对话框表单内容
      coordinateGet: false, //是否获取点击坐标
      coordinateData: {}, //编辑坐标对象
      /*项目选择 */
      itemSelectionShow: false,
      /* 本页面组件属性 */
      leftTools: [
        { name: '添加管点', icon: 'addpoint.svg' },
        { name: '添加管线', icon: 'addline.svg' },
        { name: '多边形框选', icon: 'polygon.svg' },
        { name: '测距', icon: 'ranging.svg' },
        { name: '测面', icon: 'surface.svg' },
        { name: '查找', icon: 'search.svg' }
        // 这里需要添加其他 svg 文件对应的工具
      ],
      /*右侧工具栏 */
      isLuminance: false, //亮度切换
      centerTools: [
        // 原有的工具栏项目
      ],
      markerPropList: [], //当前类型管点属性列表
      linePropList: [], //当前类型管线属性列表
      /**地图对象区域 */
      /*地图基础属性 */
      map: null, // 地图实例
      icon: {}, //图标对象
      zoom: 16, //地图比例
      mapCanvas: null, //Canvas添加图层
      /*图层显示 */
      /*当前操作图层 */
      temporaryData: [], //临时对象 用于添加管点的时候到地图上的显示
      /*图层管理 */
      handleLayerRefresh: 0,
      handleLayerData: [], //图层管理数据
      handleLayerMap: new Map(), //图层隐藏 显示map
      handleLayerGenerateList: ['特征点', '附属物', '构筑物'], //生成列表
      /*标注部分 */
      //物探点标注是否显示
      intuitionPointLabelShow: false,
      intuitionPointLabelMap: new Map(),
      //高程标注是否显示
      elevationLabelShow: false,
      elevationLabelMap: new Map(),
      /*底图基础数据 */
      tileLayers: [], //底图数组
      mapType: { // 底图类型
        name: 'Satellite'
      },
      currentBaseMap: '天地影像',
      /*marker点 */
      currentMarker: {},//当前点击点对象
      connectionMarker: {},//当前点击点对象
      markerMap: new Map(), //点MAP对象
      /*line线 */
      currentLine: {},//当前点击线对象
      lineMap: new Map(), //线MAP对象
      lineStyle: { //线样式
        default: { color: '#00ff12', weight: 2 }, //默认样式
        checked: { color: 'red', weight: 2 }, //点击后样式
        cover: { weight: 13, fillOpacity: 0, opacity: 0 } //不显示线覆盖到线之上(用于更好点击)
      },
      /*工具操作 */
      /*多边形框选 */
      boxSelectState: false, // 是否开启框选
      drawnItems: null, // 绘制的图层组
      drawControl: null, // 绘制控件
      drawHandler: null, // 绘制处理器
      /*测距操作 */
      rangingState: false, //是否开启测距
      rangingData: [], //测距对象
      rangingIndex: 0, //当前测距索引
      /*测面操作 */
      surfaceState: false, //是否测面操作
      surfaceData: null, //测面对象
      /*Popup */
      currentPopup: null, //当前弹框
      moveShow: false, //移动显示
      //右键编辑页静态图片
      updateImg: require('@/assets/collect/update.svg'),
      coordinateImg: require('@/assets/collect/coordinate.svg'),
      deleteImg: require('@/assets/collect/delete.svg'),
      moveImg: require('@/assets/collect/move.svg'),
      /* 地图控制显示*/
      highlightData: {}, //高亮显示
      /**其他属性 */
      originalFooterDisplay: undefined,
      filterDetailVisible: false,
      filterDetailData: [],
      selectedDetailKeys: [],
      filterDetailColumns: [],
      filterType: 1,
      templateList: [],
      selectedTemplateId: undefined,
      selectedTemplateType: null,
      exportLoading: false,
    }
  },
  watch: {
    formPropObject (newVal) {
      this.clearAllPopups(); //删除所有Popup 以防再表单操作中对其的影响
      console.log(newVal);
      if (newVal.title == '添加管点') {
        //添加光标样式
        L.DomUtil.addClass(this.map._container, 'leaflet-cursor-get');
      } else {
        //删除光标样式
        L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-get');
      }
    },
    //监听坐标编辑
    coordinateShow (newVal) {
      if (!newVal) {
        this.coordinateGet = false;
        //删除光标样式
        L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-get');
      }
    },
    //监听过滤表显示
    filterDetailVisible (newVal) {
      //如果取消过滤表则清除高亮显示
      if (!newVal) {
        this.clearAwayHighlight();
      } else {
        this.hideModule();
      }
    },
    //监听多边型框选显示
    polygonShow (newVal) {
      //如果取消则清除高亮显示
      if (!newVal) {
        this.clearAwayHighlight();
      } else {
        this.filterDetailVisible = false
      }
    },
    //监听是否显示物探点标注
    intuitionPointLabelShow (newVal) {
      if (newVal) {
        this.addLabelShow('intuitionPoint');
      } else {
        this.delLabelShow('intuitionPoint');
      }
    },
    //监听是否显示高程标注
    elevationLabelShow (newVal) {
      if (newVal) {
        this.addLabelShow('elevation');
      } else {
        this.delLabelShow('elevation');
      }
    },
    //监听切换亮度
    isLuminance (newVal) {
      if (newVal) {
        this.appendLuminance();
      } else {
        this.removeLuminance();
      }
    },
    //监听表单的显示
    formShow (newVal) {
      if (!newVal) {
        //如果表单隐藏 清除临时对象
        this.delTemporaryData();
      }
    },
    //监听移动管点
    moveShow (newVal) {
      if (newVal) {
        //添加光标样式
        L.DomUtil.addClass(this.map._container, 'leaflet-cursor-get2');
      } else {
        //删除光标样式
        L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-get2');
        //删除临时对象
        this.delTemporaryData();
        this.currentMarker = {}
      }
    },
    //监听查询显示
    queryShow (newVal) {
      if (!newVal) {
        this.clearAwayHighlight();
      }
    }
  },
  created () {
    console.log('在实例初始化之后调用')
  },
  beforeDestroy () {
  },

  mounted () {
    this.createProject();

    // 配置全局notification容器
    notification.config({
      top: 100,
      duration: 4,
      maxCount: 3,
      getContainer: () => document.getElementById('pipeline-mapping') || document.body
    });


  },
  methods: {
    resetData () {
      this.map.remove(); // 销毁旧的地图实例
      Object.assign(this.$data, this.$options.data.call(this))
    },
    createProject () {
      //获取项目Id
      this.currentProjectId = this.$route.query.currentProjectId;
      if (this.currentProjectId != undefined) {
        this.$http.get(this.queryProjectInfoUrl + this.currentProjectId).then(res => {
          this.projectInfo = res.data
        });
      }

      //查询管类列表
      this.queryTypeList();
      // 挂载插件
      Provider(L);
      // 初始化地图
      this.initializeMap(); //加载地图属性
      this.getProjectData(); //获取项目物探点,线信息

      // 使用更可靠的方式隐藏页脚
      setTimeout(() => {
        const footer = document.querySelector('.ant-layout-footer');
        if (footer) {
          this.originalFooterDisplay = footer.style.display;
          footer.style.display = 'none';
        }
      }, 100);
    },
    /**
     * 处理来自PolygonModule的事件
     * @param data 传递的数据对象
     */
    handlePolygonEvent (data) {
      // 根据事件类型处理不同的逻辑
      if (data.type === 'showErrorCheckResults') {
        // 使用ref获取ToolbarModule组件
        const toolbarComponent = this.$refs.toolbarModule;

        if (!toolbarComponent) {
          this.$message.error('工具栏组件未加载，请稍后重试');
          return;
        }

        try {
          // 设置错误检查结果数据
          toolbarComponent.$set(toolbarComponent, 'errorCheckResults', data.data);

          // 处理管点表错误数据
          const pointErrorTypeResult = data.data?.pointErrorTypeResult || {};
          toolbarComponent.$set(toolbarComponent, 'pointErrorLists', {
            isolationPointList: pointErrorTypeResult.isolationPointList || [],
            numberOfErrorsList: pointErrorTypeResult.numberOfErrorsList || [],
            nullValueList: pointErrorTypeResult.nullValueList || [],
            fillInTheErrorList: pointErrorTypeResult.fillInTheErrorList || []
          });

          // 处理管线表错误数据
          const pipelineErrorTypeResult = data.data?.pipelineErrorTypeResult || {};
          toolbarComponent.$set(toolbarComponent, 'pipelineErrorLists', {
            fillInTheErrorList: pipelineErrorTypeResult.fillInTheErrorList || [],
            nullValueList: pipelineErrorTypeResult.nullValueList || [],
            pipelineIsTooLongList: pipelineErrorTypeResult.pipelineIsTooLongList || []
          });

          // 显示错误详情对话框
          toolbarComponent.showErrorDetailDialog = true;

          // 使用nextTick确保DOM更新后再操作
          this.$nextTick(() => {
            setTimeout(() => {
              // 根据传入的activeTab切换到相应的标签页
              const container = document.getElementById('pipeline-mapping');
              if (!container) {
                this.$message.error('找不到容器元素');
                return;
              }

              if (data.activeTab === 'point') {
                // 默认显示管点标签页
                const tabsElement = container.querySelector('.ant-tabs-nav .ant-tabs-tab:nth-child(1)');
                if (tabsElement) {
                  tabsElement.click();
                  toolbarComponent.selectFirstNonEmptyTab();
                } else {
                  this.$message.warning('找不到管点标签页元素');
                }
              } else if (data.activeTab === 'line') {
                // 切换到管线标签页
                const tabsElement = container.querySelector('.ant-tabs-nav .ant-tabs-tab:nth-child(2)');
                if (tabsElement) {
                  tabsElement.click();
                  toolbarComponent.selectFirstNonEmptyPipelineTab();
                } else {
                  this.$message.warning('找不到管线标签页元素');
                }
              }
            }, 100); // 给一个小延时确保DOM已经渲染
          });
        } catch (error) {
          console.error('处理数据查错结果时出错:', error);
          this.$message.error('处理数据查错结果失败');
        }
      }
    },
    beforeDestroy () {
      // 恢复页脚显示
      const footer = document.querySelector('.ant-layout-footer');
      if (footer && this.originalFooterDisplay !== undefined) {
        footer.style.display = this.originalFooterDisplay;
      }
    },
    /**
     * DOM 元素移动到全屏容器内
     */
    getContainer () {
      return document.getElementById('pipeline-mapping');
    },
    /**PC端接口 API*/
    /**
     * API-TYPELIST
     */
    async queryProjectInfo () {
      const markerParams = {
        "tubeClassId": this.projectData.tubeClassSettingId,
        "tubesOrLines": 1
      };
      const lineParams = {
        "tubeClassId": this.projectData.tubeClassSettingId,
        "tubesOrLines": 2
      };
      //请求点属性数据
      const markerBasicInfo = await this.$http.post(this.queryBasicInfo, markerParams).then(res => { return res.data });
      this.markerPropList = sortBasicInfoList(markerBasicInfo);
      this.handleLayerData = sortBasicInfoTree(markerBasicInfo, this.handleLayerGenerateList);
      //请求线属性数据 
      const lineBasicInfo = await this.$http.post(this.queryBasicInfo, lineParams).then(res => { return res.data });
      this.linePropList = sortBasicInfoList(lineBasicInfo);
    },
    /**
     * API-TYPE
     */
    queryTypeList () {
      this.$http.get(this.queryTypeListUrl).then(res => {
        this.typeList = res.data;
        this.projectData = {
          tubeClassSettingId: res.data[0].id,
          tubeClassCode: res.data[0].tubeClassCode,
        }
        this.queryProjectInfo(); //查询项目当前类型列表
      })
    },
    /**
     * API01
     * 获取项目详情 
     */
    getProjectData () {
      this.spinning = true
      if (!this.currentProjectId) {
        this.itemSelectionShow = true
        return;
      }
      this.$http.get(this.queryProjectUrl + this.currentProjectId).then(res => {
        const lineResponse = res.data.pipelineInfoPcList  //线数据
        const pointResponse = res.data.pipePointInfoPcList  //点数据
        this.loadProject({ lineResponse, pointResponse }); //加载项目管点,管线信息到Map中
        //取消遮罩层
        this.spinning = false;
      })
    },
    /**
     * API02
     * 添加管点
     * @param parameter 形参
     */
    async insertMarkerApi (parameter) {
      try {
        const res = await this.$http.post(this.insertMarkerUrl, parameter);
        if (res.code !== 0) { // 判断 res.code 是否为 0
          console.error('请求失败，错误码:', res.code);
          return false; // 返回 false
        }
        // 添加管点
        this.addMarker(res.data);
        return true; // 返回 true
      } catch (error) {
        console.error('请求报错:', error);
        return false; // 返回 false
      }
    },
    /**
     * API03
     * 修改管点
     * @param parameter 形参
     */
    async updateMarkerApi (parameter) {
      //如果多边型框存在重置多边型表单查询
      if (this.polygonShow) { this.polygonQueryRefresh = Date.now() };
      try {
        const res = await this.$http.post(this.updateMarkerUrl, parameter);
        if (res.code !== 0) { // 判断 res.code 是否为 0
          console.error('请求失败，错误码:', res.code);
          return false; // 返回 false
        }
        //编辑管点
        this.editMarker(res.data.pipePointInfo);
        return true; // 返回 true
      } catch (error) {
        console.error('请求报错:', error);
        return false; // 返回 false
      }
    },
    /**
     * API04
     * 通过id删除管点
     * @param data 物探点数据
     */
    deleteMarkerORLine (data, type) {
      //判断删除类型获取url
      let url = type == 'line' ? this.deleteLineUrl : this.deleteMarkerUrl
      this.$http.get(url + data.id).then(res => {
        if (res.code == 0) {
          // 根据类型执行不同的删除操作
          type === 'line' ? this.delLine(data.id) : this.delMarker(data.intuitionPoint, res.data);
          // 如果多边型框存在，重置多边型表单查询
          if (this.polygonShow) {
            this.polygonQueryRefresh = Date.now();
            //删除高亮线和点
            this.clearHighlightMAndL(data.intuitionPoint, res.data);
          }
        }
      })
    },
    /**
     * API05
     * 插入管点
     * @param parameter 插入数据
     * @param lineId 需删除线id
     */
    async insertionMarkerApi (parameter, lineId) {
      try {
        const res = await this.$http.post(this.insertionMarkerUrl, parameter);
        if (res.code !== 0) { // 判断 res.code 是否为 0
          console.error('请求失败，错误码:', res.code);
          return false; // 返回 false
        }
        //插入管点
        this.interlayMarker(res.data, lineId);
        return true; // 返回 true
      } catch (error) {
        console.error('请求报错:', error);
        return false; // 返回 false
      }
    },
    /**
     * API06
     * 修改管线
     * @param parameter 管线修改数据
     */
    async updateLineApi (parameter) {
      //如果多边型框存在重置多边型表单查询
      if (this.polygonShow) { this.polygonQueryRefresh = Date.now() };
      try {
        const res = await this.$http.post(this.updateLineUrl, parameter);
        if (res.code !== 0) { // 判断 res.code 是否为 0
          console.error('请求失败，错误码:', res.code);
          return false; // 返回 false
        }
        //编辑管线信息
        this.editLine(res.data);
        return true; // 返回 true
      } catch (error) {
        console.error('请求报错:', error);
        return false; // 返回 false
      }
    },
    /**
     * API07
     * 添加管线
     * @param parameter 管线数据
     */
    async insertLineApi (parameter) {
      try {
        const res = await this.$http.post(this.insertLineUrl, parameter);
        if (res.code !== 0) { // 判断 res.code 是否为 0
          console.error('请求失败，错误码:', res.code);
          return false; // 返回 false
        }
        //添加新线 & 修改相关线信息
        this.addLineAndEditRelevance(res.data);
        return true; // 返回 true
      } catch (error) {
        console.error('请求报错:', error);
        return false; // 返回 false
      }
    },
    /**
     * API08
     * 移动管点
     * @param parameter 移动位置与id
     */
    moveMarkerApi (parameter, type) {
      //判断是否是地图点击移动 OR 输入坐标移动
      let url = type == 'move' ? this.moveMarkerUrl : this.fillMarkerUrl
      this.$http.post(url, parameter).then(res => {
        //移动点和线
        this.moveMarkerAndLine(res.data);
        //移动坐标后取消移动坐标操作
        if (type == 'move') { this.moveShow = false }
      })
    },
    /**
     * API09
     * 查询多边形内的值
     * @param latlngs 多边形坐标
     */
    queryBoxSelectApi (latlngs) {
      let parameter = {
        projectManagementId: this.currentProjectId,
        pointList: latlngs
      }
      this.$http.post(this.queryBoxSelectUrl, parameter).then(res => {
        this.polygonQueryData = parameter;
        //高亮查询结果
        this.showHighlightData(res.data, 3);
      })
    },
    /**
     * API10
     * 批量删除管点列表
     * @param idList 删除管线列表
     */
    deleteBatchMarkerApi (idList) {
      this.$http.post(this.deleteBatchMarkerUrl, idList).then(res => {
        this.anewloadProjectMap();
      })
    },
    /**
     * API11
     * 批量删除管线列表
     * @param idList 删除管线列表
     */
    deleteBatchLineApi (idList) {
      this.$http.post(this.deleteBatchLineUrl, idList).then(res => {
        this.anewloadProjectMap();
      })
    },
    /**组件事件区域 ZJ*/
    /**
     * ZJ01
     * 左侧工具栏点击事件
     * @param item 点击对象
     */
    handleToolClick (item) {
      console.log(item);
      switch (item.name) {
        case '添加管点':
          this.formController('marker', '添加管点', this.markerPropList);
          break;
        case '添加管线':
          this.formController('line', '添加管线', this.linePropList);
          break;
        case '多边形框选':
          this.toggleBoxSelect();
          break;
        case '测距':
          this.toggleRangingState();
          break;
        case '测面':
          this.toggleSurfaceState();
          break;
        case '查找':
          this.queryController();
          break;
        default:
          break;
      }

    },
    /* 子组件事件 ZZJ*/
    /**
     * ZZJ01
     * 表单组件传值
     * @param item 传参
     */
    async formModule (item) {
      console.log(item);
      let flag = true
      let parameter = {
        ...item.data, ...{
          tubeClassSettingId: this.projectData.tubeClassSettingId,
          tubeClassCode: this.projectData.tubeClassCode,
          projectManagementId: this.currentProjectId
        }
      }
      switch (item.controls) {
        case '添加管点':
          flag = await this.insertMarkerApi(parameter);
          break;
        case '编辑管点':
          flag = await this.updateMarkerApi(parameter);
          break;
        case '插入管点':
          flag = await this.insertionMarkerApi(parameter, this.currentLine.options.element.id);
          break;
        case '编辑管线':
          flag = await this.updateLineApi(parameter);
          break;
        case '添加管线':
          flag = await this.insertLineApi(parameter);
        default:
          break;
      }
      if (flag) {
        //删除相关属性
        this.currentLine = {};
        //删除表单框和表单属性列表
        this.formPropObject = {};
        this.formShow = false;
      }
    },
    /**
     * ZZJ02
     * 表单组件控制器
     */
    formController (type, title, list, data) {
      this.resetState();
      this.filterDetailVisible = false; //清除过滤框
      //如果是一样的操作则取消
      if (this.formPropObject.type == type
        && this.formPropObject.title == title
        && this.formPropObject.data == data) {
        //删除表单框和表单属性列表
        this.formPropObject = {};
        this.formShow = false;
        return;
      }
      //先隐藏其他框
      // 如果 formShow 为 true，先隐藏表单，延迟再执行后续逻辑
      if (this.formShow) {
        this.hideModule();
        // 延迟 500 毫秒执行后续逻辑
        setTimeout(() => {
          this.formPropObject = { type, title, list, data };
          this.formShow = true;
        }, 500); // 延迟 0.5 秒（500 毫秒）
      } else {
        this.hideModule();
        // 如果 formShow 为 false，直接执行逻辑
        this.formPropObject = { type, title, list, data };
        this.formShow = true;
      }
    },
    /**
     * ZZJ03
     * 查询组件传值
     * @param item 子组件传参
     */
    queryModule (item) {
      // 关闭组件
      if (item == 'close') {
        this.queryShow = false;
      } else {
        if (item.type == 'query') {
          this.goToMarker(item.data);
          console.log(item.line);

          if (item.line != undefined) {
            this.clearAwayHighlight();
            //显示相关联高亮线
            this.showHighlightData(item.line, 2);
          }
          // this.queryShow = false;
        }
      }
    },
    /**
     * ZZJ04
     * 查询组件控制器
     */
    queryController () {
      let flag = this.queryShow;
      //先隐藏其他框
      this.hideModule();
      this.queryShow = !flag;
    },
    /**
     * ZZJ05
     * 多边框选组件传值
     */
    polygonModule (item) {
      console.log('多边框选组件传值', item);
      let formData = {}; //表单组件传值
      // 关闭组件
      if (item == 'close') {
        this.toggleBoxSelect();
      } else if (item.type && typeof item.type === 'string') {
        // 处理事件消息
        if (item.type === 'showErrorCheckResults') {
          this.handlePolygonEvent(item);
          return;
        }

        //判断传输类型
        switch (item.type) {
          case 'marker': //编辑管点
            //当前管点对象获取修改前点位
            if (item.data.tubeClassCode != this.projectData.tubeClassCode) { this.$message.warning('请将类型设置同一管类'); return; }
            this.currentMarker = this.markerMap.get(item.data.intuitionPoint);
            formData = { type: item.type, title: '编辑管点', list: this.markerPropList, data: item.data };
            break;
          case 'line':  //编辑管线
            if (item.data.tubeClassCode != this.projectData.tubeClassCode) { this.$message.warning('请将类型设置同一管类'); return; }
            formData = { type: item.type, title: '编辑管线', list: this.linePropList, data: item.data };
            break;
          case 'delmarker': //删除管点
            //删除管线和管点
            this.deleteMarkerORLine(item.data, 'marker')
            //如果多边型框存在重置多边型表单查询
            return;
          case 'delline': //删除管线
            //删除管线
            this.deleteMarkerORLine(item.data, 'line')
            //删除高亮线
            this.clearHighlightLine(item.data.id);
            //如果多边型框存在重置多边型表单查询
            return;
          case 'batchDelmarker': //批量删除管点
            this.deleteBatchMarkerApi(item.data);
            setTimeout(() => {
              //删除高亮点线
              this.clearAwayHighlight();
              //告知多边框选择框 重新查询
              this.polygonQueryRefresh = Date.now();
            }, 100);
            setTimeout(() => {
              //重新高亮点线
              this.queryBoxSelectApi(this.polygonQueryData.pointList);
            }, 200);
            return;
          case 'batchDelline': //批量删除管点
            this.deleteBatchLineApi(item.data);
            setTimeout(() => {
              //删除高亮点线
              this.clearAwayHighlight();
              //告知多边框选择框 重新查询
              this.polygonQueryRefresh = Date.now();

            }, 100);
            setTimeout(() => {
              //重新高亮点线
              this.queryBoxSelectApi(this.polygonQueryData.pointList);
            }, 200);
            return;
          case 'toggle': //切换管点,管线类型
            this.formShow = false;
            //当前管点对象清除
            this.currentMarker = {};
            return;
          default:
            break;
        }
        //判断表单显示
        if (this.formShow) {
          //先隐藏表单
          this.formShow = false;
          //延迟显示表单
          setTimeout(() => {
            this.formPropObject = formData;
            this.formShow = true;
          }, 500);
        } else {
          //自己显示表单
          this.formPropObject = formData;
          this.formShow = true;
        }

      }

    },
    /**
     * ZZJ06
     * 坐标编辑组件传值
     */
    coordinateModule (item) {
      console.log('坐标编辑组件传值', item);
      // 关闭组件
      if (item == 'close') {
        this.coordinateShow = false
      } else if (item.type == 'get') { //获取坐标
        if (item.flag) {
          this.coordinateGet = true
          //添加光标样式
          L.DomUtil.addClass(this.map._container, 'leaflet-cursor-get');
        } else {
          this.coordinateGet = false
          //删除光标样式
          L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-get');
        }
      } else if (item.type == 'move') { //移动管点
        this.moveMarkerApi(item.data, item.type);
        this.coordinateShow = false;
      } else if (item.type == 'fill') { //输入修改坐标
        this.moveMarkerApi(item.data, item.type);
        this.coordinateShow = false;
      }
    },
    /**
     * ZZJ07
     * 改变管类类型
     */
    handleProjectDataUpdate (newData) {
      this.projectData = newData; // 更新父组件的数据
      //表单框
      this.formPropObject = {};
      this.formShow = false;
      this.queryProjectInfo(); //查询项目当前类型列表
    },
    /**
     * ZZJ08
     * 查看图层隐藏显示点
     */
    showLayerType (item) {
      if (item.show) {
        this.revealDataToLayerMap(item.key);
      } else {
        this.hiddenDataToLayerMap(item.key);
      }
    },
    /**
     * ZZJ09
     * 项目选择
     */
    itemSelection () {
      this.itemSelectionShow = true
      this.filterDetailVisible = false
    },
    /**
     * ZZJ10
     * 项目选择框回调修改值
     */
    itemSelectionShowUpdate (newVal) {
      if (this.currentProjectId == undefined) {
        this.$message.warning('请选择项目');
        return;
      }
      this.itemSelectionShow = newVal
    },
    /**
     * ZZJ11
     * 切换项目
     * @param item 切换项目id
     */
    async toggleProject (item) {
      console.log(item); // 打印 item 的值，用于调试
      if (item == undefined) {
        this.$message.warning('请选择项目');
        return;
      }
      let newUrl = window.location.href.replace(/currentProjectId=\d+/, `currentProjectId=${item}`);
      history.replaceState(null, "", newUrl); // 修改URL，不刷新页面
      // 手动更新 Vue Router 的路由信息
      this.$router.replace({ query: { ...this.$route.query, currentProjectId: item } });
      // 调用重置地图
      this.resetData();
      this.createProject();
    },
    /**
     * ZZJ12
     * 图层亮度切换
     * @param item 图层亮度切换
     */
    isLuminanceUpdate (item) {
      console.log(item);
      this.isLuminance = item
    },
    /**
     * ZZJ13
     * 表单新增管线连线操作
     * @param item 连线对象
     */
    formOnLine (item) {
      switch (item.type) {
        case 'marker': //显示临时点
          this.addTemporaryData(null, item);
          break;
        case 'line': //显示临时线
          this.addLineTemporary();
          break;
        case 'reset': //重置临时点线
          this.delTemporaryData();
          break;
        default:
          break;
      }
    },
    /**
     * ZZJYC
     * 隐藏所有组件
     */
    hideModule () {
      //移动操作
      this.moveShow = false;
      //表单框
      this.formPropObject = {};
      this.formShow = false;
      //查询框
      this.queryShow = false;
      //坐标编辑框
      this.coordinateShow = false;
      if (this.polygonShow) {
        this.toggleBoxSelect();
      }
    },

    /**地图事件区域 */
    /**地图初始化加载 MAP */
    /**
     * MAP01
     * 初始化地图实例
     */
    initializeMap () {
      // 初始化地图实例
      this.map = L.map('map', {
        zoom: this.zoom,
        minZoom: 3,
        maxZoom: 28,
        zoomControl: false,
        attributionControl: false,
        doubleClickZoom: false,
        center: [Number(storage.get(LonLat)[1]), Number(storage.get(LonLat)[0])]
      })
      //初始化Canvas图层
      this.mapCanvas = L.canvasMarkerLayer({

        // collisionFlg: true 聚合
      }).addTo(this.map);
      // 初始化绘制图层组
      this.initDrawControl();
      // 初始化底图
      this.initBasemap();
      // 注册事件
      this.registerMapEvents();
      // 基础要素加载
      this.initializeIcon();
    },
    /**
     * MAP02
     * 初始化底图
     */
    initBasemap () {
      // 清除现有图层
      if (this.tileLayers.length > 0) {
        this.tileLayers.forEach(layer => {
          this.map.removeLayer(layer)
        })
        this.tileLayers = [];
      }
      // 添加天地影像底图
      const satelliteLayer = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        key: '485cd3a62955d7a962a5c0d64d4949f2'
      })
      // 添加天地图标注
      const annotationLayer = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        key: '485cd3a62955d7a962a5c0d64d4949f2'
      })

      // 将图层添加到地图
      satelliteLayer.addTo(this.map);
      annotationLayer.addTo(this.map);
      // 保存图层引用
      this.tileLayers = [satelliteLayer, annotationLayer];
    },
    /**
     * MAP-LD01
     * 添加黑色底图
     */
    appendLuminance () {
      // 创建一个遮罩层
      const maskDiv = L.DomUtil.create('div', 'mask-overlay');
      maskDiv.style.position = 'absolute';
      maskDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'; // 黑色半透明遮罩
      maskDiv.style.pointerEvents = 'none'; // 防止遮罩层拦截鼠标事件

      // 将遮罩层添加到 overlayPane
      this.map.getPanes().overlayPane.appendChild(maskDiv);

      // 动态调整遮罩层的位置和尺寸
      const updateMask = () => {
        const mapSize = this.map.getSize(); // 获取地图容器的尺寸
        const mapBounds = this.map.getBounds(); // 获取地图的边界
        const topLeft = this.map.latLngToLayerPoint(mapBounds.getNorthWest()); // 左上角坐标
        const bottomRight = this.map.latLngToLayerPoint(mapBounds.getSouthEast()); // 右下角坐标

        // 设置遮罩层的位置和尺寸
        maskDiv.style.width = `${bottomRight.x - topLeft.x}px`;
        maskDiv.style.height = `${bottomRight.y - topLeft.y}px`;
        maskDiv.style.left = `${topLeft.x}px`;
        maskDiv.style.top = `${topLeft.y}px`;
      };

      // 初始化遮罩层
      updateMask();

      // 监听地图尺寸变化（例如窗口调整大小）
      this.map.on('resize', updateMask);
      // 监听地图缩放和移动事件
      this.map.on('zoomend', updateMask);
      this.map.on('moveend', updateMask);
    },
    /**
     * MAP-LD02
     * 删除黑色底图
     */
    removeLuminance () {
      // 检查是否已经存在遮罩层
      const maskDiv = this.map.getPanes().overlayPane.querySelector('.mask-overlay');
      if (maskDiv) {
        // 如果遮罩层存在，则移除它
        this.map.getPanes().overlayPane.removeChild(maskDiv);

        // 移除事件监听器
        this.map.off('resize', updateMask);
        this.map.off('zoomend', updateMask);
        this.map.off('moveend', updateMask);
      }
    },
    /**
     * MAP03
     * 注册事件监听
     */
    registerMapEvents () {
      let that = this;
      // 左击点击事件
      this.map.on('click', (event) => {
        if (this.polygonShow) { return; }
        //如果是多边框选编辑状态则不触发地图事件
        if (this.formShow) {
          switch (this.formPropObject.title) {
            case '添加管点':
              this.formCoordinate = event.latlng;
              this.addTemporaryData(event.latlng);
              break;
            case '添加管线':
              //获取点击的key
              let key = this.coordinateIndex(event.latlng);
              if (key) {
                //获取当前右键对象
                let marker = this.markerMap.get(key);
                if (marker.options.element.tubeClassCode != this.projectData.tubeClassCode) {
                  this.$message.warning('当前点为' +
                    marker.options.element.intuitionPoint +
                    '请将类型设置同一管类'); return;
                }
                this.connectionMarker = { data: marker.options.element, id: Date.now() }
              }
              break;
            default:
              break;
          }
          return;
        };
        //地图点击编辑坐标
        if (this.coordinateShow) {
          if (this.coordinateGet) {
            this.coordinateData = event.latlng;
          }
          return;
        };
        //地图点击移动坐标
        if (this.moveShow) {
          this.addMoveTemporary(event.latlng);
          return;
        }
        if (this.rangingState) { this.clickRangingState(event.latlng); return; };
        if (this.surfaceState) { this.clickSurfaceState(event.latlng); return; };
        //触发地图点击事件
        this.queryMarkerPopup(event.latlng, 'info');
      })
      // 缩放事件
      this.map.on('zoomend', (event) => {
        //触发地图缩放事件
        this.mapZoom(event.target.getZoom());
      })
      // 右击点击事件
      this.map.on("contextmenu", (event) => {
        //如果是多边框选编辑状态则不触发地图事件
        if (this.formShow || this.polygonShow || this.coordinateGet) { return; };
        if (this.moveShow) { this.moveShow = false; return; }
        if (this.rangingState) { this.contextmenuRangingState(); return; };
        if (this.surfaceState) { this.toggleSurfaceState(); return; };
        this.queryMarkerPopup(event.latlng, 'editor');
      })
    },
    /**
     * MAP04
     * 加载项目
     * @param data 项目数据 { lineResponse, pointResponse } 线数据,点数据
     */
    async loadProject (data) {
      await data.pointResponse.forEach(element => {
        this.addMarker(element);
      })
      await data.lineResponse.forEach(element => {
        this.addLine(element);
      });
    },
    /**
     * MAP05
     * 初始化绘制图层组
     */
    initDrawControl () {
      // 初始化绘制图层组
      this.drawnItems = new L.FeatureGroup();
      this.map.addLayer(this.drawnItems);
    },
    /**
     * MAP06
     * 批量删除修改重置项目地图
     */
    anewloadProjectMap () {
      this.handleLayerRefresh = Date.now(); // 异步更新
      //先删除所有点线
      this.removeProjectMarkerANDLine();
      this.intuitionPointLabelShow = false
      this.elevationLabelShow = false
      //然后重新加载项目
      this.getProjectData();
    },
    /**
     * MAP07
     * 查看点或线
     */
    queryMapMssage (item) {
      console.log(item);
      if (item.type == '1') {
        this.goToMarker(item.data.intuitionPoint);
      } else if (item.type == '2') {
        this.goToLine(item.data.id);
      }
    },
    /**
     * MAP-RM
     * 删除地图管点管线
     */
    removeProjectMarkerANDLine () {
      //删除所有点
      this.markerMap.forEach(item => {
        this.delMarker(item.options.element.intuitionPoint);
      })
      //重绘图层
      this.mapCanvas.redraw();
      //重新加载点Map
      this.markerMap = new Map();

      //删除所有线
      this.lineMap.forEach(item => {
        this.delLine(item.polyline.options.element.id)
      })
      //重新加载点Map
      this.lineMap = new Map();
    },
    /**临时对象操作 MAPLS*/
    /**
     * MAPLS01
     * 创建临时对象
     * @param latlng 临时对象坐标
     * @param data 连线对象
     */
    addTemporaryData (latlng, data = {}) {
      //data为0则是点对象生成
      if (!Object.keys(data).length) {
        if (this.temporaryData.length) {
          this.moveTemporaryData(latlng);
          return this.temporaryData[0];
        }
        let marker = L.circleMarker(latlng, {
          radius: 5,              // 圆点半径
          fillColor: "#08E717",    // 填充颜色
          color: "#fff",        // 边框颜色
          weight: 2,               // 边框宽度
          opacity: 1,              // 边框透明度
          fillOpacity: 1,        // 填充透明度

        }).addTo(this.map);
        this.temporaryData.push(marker);
        return marker;
      } else {
        let markerData = this.markerMap.get(data.intuitionPoint);
        let marker = L.circleMarker(markerData.getLatLng(), {
          radius: 5,              // 圆点半径
          fillColor: "#08E717",    // 填充颜色
          color: "#fff",        // 边框颜色
          weight: 2,               // 边框宽度
          opacity: 1,              // 边框透明度
          fillOpacity: 1,        // 填充透明度

        }).addTo(this.map);
        this.temporaryData.push(marker);
      }
    },

    /**
     * MAPLS02
     * 对点临时对象的移动
     * @param latlng 临时对象坐标
     */
    moveTemporaryData (latlng) {
      this.temporaryData[0].setLatLng(latlng);
    },
    /**
     * MAPLS03
     * 添加移动管点临时对象 
     * 与临时对象移动不同 此操作用于移动现有管点坐标
     * @param latlng 临时对象坐标
     */
    addMoveTemporary (latlng) {
      let marker = this.addTemporaryData(latlng);
      this.movePopup(marker, latlng);
    },
    /**
     * MAPLS04
     * 添加临时线
     */
    addLineTemporary () {
      let latlngArray = []
      this.temporaryData.forEach(item => {
        latlngArray.push(item.getLatLng());
      })
      let options = {
        ...this.lineStyle.checked,
      }
      let polyline = L.polyline(latlngArray, options).addTo(this.map);
      this.temporaryData.push(polyline);
    },
    /**
     * MAPLS-Del
     * 删除临时对象
     */
    delTemporaryData () {
      this.temporaryData.forEach(item => {
        item.remove();
      })
      this.temporaryData = [];
    },
    /**图层工具事件 MAPGJ */
    /**
     * MAPGJ01
     * @param {L.LatLng} latlng 坐标
     * @returns {string|null} 返回匹配的 key，如果没有匹配的图标则返回 null
     */
    coordinateIndex (latlng) {
      let matchedKey = null;

      this.markerMap.forEach((value, key) => {
        // 获取图标的中心坐标
        let markerLatLng = value.getLatLng();
        // 获取图标的大小，例如 [12, 12]（单位：px）
        let markerSize = value.options.icon.options.iconSize;

        // 将图标的中心坐标转换为像素坐标
        let markerPixelPoint = this.map.latLngToLayerPoint(markerLatLng);
        // 将目标坐标转换为像素坐标
        let targetPixelPoint = this.map.latLngToLayerPoint(latlng);

        // 计算图标的边界范围（像素）
        let halfWidth = markerSize[0] / 2;
        let halfHeight = markerSize[1] / 2;
        // 判断目标坐标是否在图标的像素范围内
        if (targetPixelPoint.x >= markerPixelPoint.x - halfWidth &&
          targetPixelPoint.x <= markerPixelPoint.x + halfWidth &&
          targetPixelPoint.y >= markerPixelPoint.y - halfHeight &&
          targetPixelPoint.y <= markerPixelPoint.y + halfHeight) {
          this.currentMarker = value;
          matchedKey = key; // 记录匹配的 key
          return; // 退出循环
        }
      });
      return matchedKey; // 返回匹配的 key，如果没有匹配则返回 null
    },
    /**图层控制事件 MAPKC */
    /**
     * MAPKC01 
     * 添加标注
     * @param type 类型
     */
    addLabelShow (type) {
      const iconConfigs = {
        intuitionPoint: {
          className: 'custom-div-icon',
          html: (value) => `
        <div class="line-container">
          <div class="slanted-line"></div>
          <div class="straight-line"></div>
          <span class="divIcon-text">${value}</span>
        </div>`,
          iconSize: [30, 30],
          iconAnchor: [-10, 40],
          labelMap: 'intuitionPointLabelMap',
          valueField: 'intuitionPoint'
        },
        elevation: {
          className: 'custom-div-icon',
          html: (value) => `
        <div class="line-container-gc">
          <div class="slanted-line-gc"></div>
          <div class="straight-line-gc"></div>
          <span class="divIcon-text-gc">${value == undefined ? '0' : value}</span>
        </div>`,
          iconSize: [30, 30],
          iconAnchor: [210, 40],
          labelMap: 'elevationLabelMap',
          valueField: 'groundElevation'
        }
      };

      const config = iconConfigs[type];
      if (!config) {
        console.warn(`Unknown type: ${type}`);
        return;
      }

      const showMap = new Map();
      this.markerMap.forEach((marker, key) => {
        const value = marker.options.element[config.valueField];
        const divIcon = L.divIcon({
          className: config.className,
          html: config.html(value),
          iconSize: config.iconSize,
          iconAnchor: config.iconAnchor
        });

        const labelMarker = L.marker(marker.getLatLng(), {
          icon: divIcon,
        }).addTo(this.map);

        showMap.set(key, labelMarker);
      });

      this[config.labelMap] = showMap;
    },
    /**
     * MAPKC02
     * 删除标注
     * @param type 类型
     */
    delLabelShow (type) {
      let map = new Map();
      switch (type) {
        case 'intuitionPoint':
          map = this['intuitionPointLabelMap']
          break;
        case 'elevation':
          map = this['elevationLabelMap']
          break;
        default:
          this.delLabelShow('intuitionPoint');
          this.delLabelShow('elevation')
          break;
      }
      map.forEach((value, key) => {
        value.remove();
      })
      map = new Map();
    },
    /**
     * MAPKC03
     * 通过intuitionPoint删除标注
     * @param key 键
     */
    delLabelShowByKey (key) {
      if (!this.intuitionPointLabelMap || !this.elevationLabelMap) {
        return;
      }
      // 定义一个通用的删除函数
      const removeMarker = (labelMap, key) => {
        const marker = labelMap.get(key);
        if (marker) {
          marker.remove(); // 移除 marker
          labelMap.delete(key); // 从 Map 中删除 key
        } else {
          console.warn(`Marker with key "${key}" not found in labelMap.`);
        }
      };
      // 删除 intuitionPoint 和 elevation 的 marker
      removeMarker(this.intuitionPointLabelMap, key);
      removeMarker(this.elevationLabelMap, key);
    },
    /**
     * 隐藏类型点
     * MAPKC04 
     */
    hiddenDataToLayerMap (value) {
      let list = []
      this.markerMap.forEach((item, key) => {
        if (item.options.element.structure == value) {
          list.push(item.options.element);
          //删除图层中的管点
          this.mapCanvas.removeLayer(item);
          //删除标注
          this.delLabelShowByKey(item.options.element.intuitionPoint);
        }
      });
      this.handleLayerMap.set(value, list);
    },
    /**
     * 显示类型点
     * MAPKC05
     */
    revealDataToLayerMap (value) {
      let list = this.handleLayerMap.get(value);
      list.forEach(item => {
        this.addMarker(item)
      })
      this.handleLayerMap.delete(value);
    },
    /**图层服务事件 MAPFW */

    /**
     * MAPFW01
     * 地图点击事件
     * @param latlng 点击坐标
     */
    mapClick (latlng) {
      //查询点信息弹框显示
      this.queryMarkerPopup(latlng, 'info');
    },
    /**
     * MAPFW02
     * 地图缩放事件
     * @param zoom 缩放大小
     */
    mapZoom (zoom) {
      this.zoom = zoom;
    },
    /**
     * MAPFW03
     * 添加管点标记
     * @param data 管点数据
     */
    addMarker (data) {
      //获取点位图标
      let pointInfo = this.judgeIcon(data.structure, data.closingPoints);
      //创建点位坐标
      let latlngArray = [data.cgCsLatitude, data.cgCsLongitude];
      //创建 markerIcon icon 点位图标对象
      let markerIcon = L.icon({ iconUrl: pointInfo.pointIcon.iconUrl, iconSize: pointInfo.pointIcon.iconSize, iconAnchor: [5, 6] });
      //创建 marker 项目点位数据
      let marker = L.marker(latlngArray, { icon: markerIcon, element: data });
      //添加进canvas图层对象
      this.mapCanvas.addLayer(marker);
      //存储点位数据
      this.markerMap.set(data.intuitionPoint, marker);
    },
    /**
     * MAPFW04
     * 添加管线图层
     * @param data 管线数据
     */
    addLine (data) {
      //创建线坐标
      let latlngArray =
        data.beginLatitude == null ?
          [this.markerMap.get(data.connectionPointNumber).getLatLng(), this.markerMap.get(data.theDotNumberIsConnected).getLatLng()] :
          [[data.beginLatitude, data.beginLongitude], [data.endLatitude, data.endLongitude]];
      //创建线
      let options = {
        element: data,
        ...this.lineStyle.default
      }
      let polyline = L.polyline(latlngArray, options).addTo(this.map);

      let coverOptions = {
        ...this.lineStyle.cover
      }
      //创建不显示线 目的为更容易点击
      let coverPolyline = L.polyline(latlngArray, coverOptions).addTo(this.map);
      //给不显示线添加事件
      //鼠标点击事件 选中管线
      coverPolyline.on("click", e => {
        //如果是多边框选编辑状态则不触发地图事件
        if (this.polygonShow || this.rangingState || this.surfaceState || this.formShow || this.coordinateShow) {
          return;
        }
        //获取点击的key
        //添加线弹窗内容
        let popup = this.createLinePopup(polyline.options.element, e.latlng);
        //鼠标移入弹窗
        popup.openOn(this.map);
        this.currentPopup = popup;
      });

      coverPolyline.on("contextmenu", e => {
        //如果是多边框选编辑状态则不触发地图事件
        if (this.polygonShow || this.rangingState || this.surfaceState || this.formShow || this.coordinateShow) {
          return;
        }
        //添加线弹窗内容
        let popup = this.createEditorPopup(polyline, 'line', e.latlng);
        popup.openOn(this.map);
        this.currentPopup = popup;
      });
      //添加线集合
      this.lineMap.set(data.id, { polyline, coverPolyline });
    },
    /**
     * MAPFW05
     * 删除管点
     * @param id 编号
     */
    delMarker (id, data = []) {
      //获取管点
      let marker = this.markerMap.get(id);
      //删除图层中的管点
      this.mapCanvas.removeLayer(marker);
      //清除map里的点位信息
      this.markerMap.delete(id);
      //如果data有则循环删除相关线
      data.forEach(item => {
        this.delLine(item.id);
      })
      //删除标注
      this.delLabelShowByKey(id);
    },
    /**
     * MAPFW06
     * 删除管线
     * @param id 组件id
     */
    delLine (id) {
      //获取管线
      let line = this.lineMap.get(id);
      //删除显示线
      line.polyline.remove();
      //删除点击线
      line.coverPolyline.remove();
      //清除map里的线信息
      this.lineMap.delete(id);
    },
    /**
     * MAPFW07
     * 修改管点
     * @param data 修改后数据
     */
    editMarker (data) {
      //获取原管点
      let marker = this.currentMarker;
      //删除管点
      this.delMarker(marker.options.element.intuitionPoint);
      //添加修改后管点
      this.addMarker(data);
    },
    /**
     * MAPFW08
     * 插入管点
     * @param data 插入数据包含 {pipePointInfo} 插入点对象 {pipelineInfo} 插入线集合
     * @param lineId 删除线Id
     */
    interlayMarker (data, lineId) {
      //先删除原管线
      this.delLine(lineId);
      //添加管点
      this.addMarker(data.pipePointInfo);
      //添加管线
      data.pipelineInfo.forEach(item => {
        this.addLine(item);
      })
    },
    /**
     * MAPFW09
     * 修改管线与相关管线信息
     * @param data 管线信息 {pipelineInfo} 修改线对象 {pipelineInfoList} 插入线集合
     */
    editLine (data) {
      //获取管线
      let line = this.lineMap.get(data.pipelineInfo.id);
      //重新设置线属性
      line.polyline.options.element = data.pipelineInfo;
      //循环修改相关线属性
      data.pipelineInfoList.forEach(item => {
        //获取管线
        let line = this.lineMap.get(item.id);
        //重新设置线属性
        line.polyline.options.element = item;
      })
    },
    /**
     * MAPFW10
     * 添加管线
     * @param data 管线信息 {pipelineInfo} 修改线对象 {pipelineInfoList} 插入线集合
     */
    addLineAndEditRelevance (data) {
      //添加新管线
      this.addLine(data.pipelineInfo);
      //循环修改相关线属性
      data.pipelineInfoList.forEach(item => {
        //获取管线
        let line = this.lineMap.get(item.id);
        //重新设置线属性
        line.polyline.options.element = item;
      })
    },
    /**
     * MAPFW11
     * 移动管点
     * @param data 
     */
    moveMarkerAndLine (data) {
      //先修改管点
      this.editMarker(data.pipePointInfo);
      //移动管线
      data.pipelineInfo.forEach(item => {
        //获取管线
        let line = this.lineMap.get(item.id);
        //创建线坐标
        let latlngArray =
          item.beginLatitude == null ?
            [this.markerMap.get(item.connectionPointNumber).getLatLng(), this.markerMap.get(item.theDotNumberIsConnected).getLatLng()] :
            [[item.beginLatitude, item.beginLongitude], [item.endLatitude, item.endLongitude]];
        //重新设置线属性
        line.polyline.options.element = item;
        line.polyline.setLatLngs(latlngArray);
        line.coverPolyline.setLatLngs(latlngArray);
      })
    },
    /**
     * MAPFW12
     * 移动到管点位置并开启详情框
     */
    goToMarker (key) {
      const marker = this.markerMap.get(key);
      if (!marker) return; // 确保标记存在
      const targetLatLng = marker.getLatLng();
      const targetZoom = 20;
      const slightlyOffset = [targetLatLng.lat + 0.0001, targetLatLng.lng + 0.0001];
      this.map.setView(slightlyOffset, targetZoom - 0.1);

      setTimeout(() => {
        this.map.setView(targetLatLng, targetZoom);
      }, 50);
      // 更新弹窗内容并打开
      const popupInfo = this.createMarkerPopup(marker.options.element);
      marker
        .unbindPopup()  // 先解绑旧的（避免重复绑定）
        .bindPopup(popupInfo)
        .openPopup();
    },
    /**
      * MAPFW12
      * 移动到管点位置并开启详情框
      */
    goToLine (key) {
      let line = this.lineMap.get(key);
      if (line != undefined) {
        // 获取多段线的顶点
        let latlng = line.polyline.getLatLngs();
        // 计算中心点
        const center = this.calculateCenter(latlng);
        // 创建弹窗
        let popup = this.createLinePopup(line.polyline.options.element, center);
        popup.openOn(this.map);
        this.currentPopup = popup;
        // 将地图视图移动到中心点
        const targetZoom = 20;
        const slightlyOffset = [center[0] + 0.0001, center[1] + 0.0001];
        this.map.setView(slightlyOffset, targetZoom - 0.1);
        setTimeout(() => {
          this.map.setView(center, targetZoom);
        }, 50);
      }
    },
    /**绘制地图 HZMAP */
    /**
     * HZMAP-QH
     * 切换工具操作
     * @param type 类型
     * @param flag 原始值
     */
    resetState (type, flag) {
      // 如果当前是 boxSelect 状态且 type 不是 boxSelect，则关闭 boxSelect
      if (this.boxSelectState && type !== 'boxSelect') {
        this.toggleBoxSelect();
      }
      // 根据 type 处理不同的逻辑
      switch (type) {
        case 'boxSelect':
          this.removeCursorClasses(['leaflet-cursor-ranging', 'leaflet-cursor-surface']); // 移除相关类
          this.contextmenuRangingState(); // 重置测距状态
          this.clearAllSurfaceData(); // 清除所有面和点
          break;
        case 'Ranging':
          //先隐藏其他框
          this.hideModule();
          // 防止其他操作影响
          this.rangingState = flag;
          this.removeCursorClasses(['leaflet-cursor-surface']); // 移除相关类
          this.clearAllSurfaceData(); // 清除所有面和点
          break;
        case 'Surface':
          //先隐藏其他框
          this.hideModule();
          this.contextmenuRangingState(); // 重置测距状态
          break;
        default:
          this.removeCursorClasses(['leaflet-cursor-surface']); // 移除相关类
          // 默认情况
          this.contextmenuRangingState(); // 重置测距状态
          this.clearAllSurfaceData(); // 清除所有面和点
          break;
      }
    },
    /**
     * HZMAP-GB
     * 移除指定的 CSS 类 
     * @param classes 需要移除的类名数组
     */
    removeCursorClasses (classes) {
      classes.forEach(className => {
        L.DomUtil.removeClass(this.map._container, className);
      });
    },
    /**
     * HZMAP01
     * Draw插件 切换框选状态
     */
    toggleBoxSelect () {
      this.boxSelectState = !this.boxSelectState;
      this.resetState('boxSelect', this.boxSelectState)
      if (this.boxSelectState) {
        //先隐藏其他框
        this.hideModule();
        // 开启多边形绘制
        this.enableDrawing();
      } else {
        // 关闭多边形绘制并清除图层
        this.disableDrawing();
        this.drawnItems.clearLayers(); // 清除所有绘制的图形
        if (this.formShow) { this.formShow = false; } //如果有表单显示则一起删除
        this.polygonShow = false;
      }
    },
    /**
     * HZMAP02
     * Draw插件 启用绘制
     */
    enableDrawing () {
      // 初始化多边形绘制处理器
      this.drawHandler = new L.Draw.Polygon(this.map, {
        shapeOptions: {
          color: 'red', // 多边形颜色
        },
        allowIntersection: false, // 不允许交叉
        drawError: {
          color: 'orange', // 错误颜色
          timeout: 1000, // 错误提示时间
        },
        // showArea: true, // 显示面积
        metric: true, // 使用公制单位
      });

      // 开始绘制
      this.drawHandler.enable();

      // 监听绘制完成事件
      this.map.on(L.Draw.Event.CREATED, this.handleDrawCreated);
    },
    /**
     * HZMAP03
     * Draw插件 禁用绘制
     */
    disableDrawing () {
      if (this.drawHandler) {
        this.drawHandler.disable(); // 禁用绘制
        this.map.off(L.Draw.Event.CREATED, this.handleDrawCreated); // 移除事件监听
        this.drawHandler = null;
      }
    },
    /**
     * HZMAP04
     * Draw插件 处理绘制完成事件
     * @param event 完成对象
     */
    handleDrawCreated (event) {
      const layer = event.layer;
      console.log(event.layer._latlngs[0]);
      this.queryBoxSelectApi(event.layer._latlngs[0])
      this.drawnItems.addLayer(layer); // 将绘制的图形添加到图层组
      //显示多边框选组件
      this.polygonShow = true;
    },
    /**测面事件 MAPCM*/
    /**
     * MAPCM01
     * 测面控制器
     */
    toggleSurfaceState () {
      this.surfaceState = !this.surfaceState
      this.resetState('Surface', this.surfaceState);
      if (this.surfaceState) {
        //添加光标样式
        L.DomUtil.addClass(this.map._container, 'leaflet-cursor-surface');
      } else {
        //删除光标样式
        L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-surface');
        this.clearAllSurfaceData();
      }
    },
    /**
     * MAPCM02
     * 侧面点击事件
     */
    clickSurfaceState (latlng) {
      // 创建点
      const marker = L.marker(latlng, {
        icon: L.divIcon({
          className: 'custom-marker', // 自定义 CSS 类
          html: '<div style="background-color: #fff; width: 10px; height: 10px; border-radius: 50%; border: 2px solid red;"></div>',
          iconSize: [14, 14], // 图标大小
          iconAnchor: [5, 5]
        })
      }).addTo(this.map);

      // 初始化 surfaceData（如果不存在）
      if (!this.surfaceData) {
        this.surfaceData = {
          markers: [], // 存储所有点
          polygon: null // 存储面对象
        };
      }
      // 将点添加到 surfaceData
      this.surfaceData.markers.push(marker);
      // 如果点的数量达到 3 个，创建或更新面
      if (this.surfaceData.markers.length >= 3) {
        this.updateSurfacePolygon();
      }
    },
    /**
     * MAPCM03
     * 更新面的坐标
     */
    updateSurfacePolygon () {
      // 获取所有点的坐标
      const latlngs = this.surfaceData.markers.map(marker => marker.getLatLng());

      // 如果面不存在，则创建；否则更新
      if (!this.surfaceData.polygon) {
        this.surfaceData.polygon = L.polygon(latlngs, {
          showMeasurements: true,
          color: 'red', // 设置面边框颜色
          fillColor: 'red', // 设置面填充颜色
          fillOpacity: 0.5 // 设置面填充透明度
        }).addTo(this.map);
      } else {
        this.surfaceData.polygon.setLatLngs(latlngs);
      }
    },

    /**
     * MAPCM04
     * 删除点并更新面
     * @param marker 要删除的点
     */
    deleteSurfaceMarker (marker) {
      if (!this.surfaceData) return;
      // 从地图中移除点
      marker.removeFrom(this.map);
      // 从 surfaceData 中移除点
      this.surfaceData.markers = this.surfaceData.markers.filter(m => m !== marker);
      // 如果点的数量少于 3 个，移除面
      if (this.surfaceData.markers.length < 3) {
        if (this.surfaceData.polygon) {
          this.surfaceData.polygon.removeFrom(this.map); // 从地图中移除面
          this.surfaceData.polygon = null; // 清空面对象
        }
      } else {
        // 否则，更新面的坐标
        this.updateSurfacePolygon();
      }
    },
    /**
     * MAPCM05
     * 清除所有面和点
     */
    clearAllSurfaceData () {
      if (!this.surfaceData) return;
      // 移除所有点
      if (this.surfaceData.markers && this.surfaceData.markers.length > 0) {
        this.surfaceData.markers.forEach(marker => {
          marker.removeFrom(this.map); // 从地图中移除点
        });
        this.surfaceData.markers = []; // 清空点数组
      }
      // 移除面
      if (this.surfaceData.polygon) {
        this.surfaceData.polygon.removeFrom(this.map); // 从地图中移除面
        this.surfaceData.polygon = null; // 清空面对象
      }
      // 重置 surfaceData
      this.surfaceData = null;
      this.surfaceState = false;
    },
    /**测距事件 MAPCJ*/
    /**
     * MAPCJ01
     * 测距控制器
     */
    toggleRangingState () {

      console.log(this.rangingState);
      this.rangingState = !this.rangingState
      this.resetState('Ranging', this.rangingState);
      if (this.rangingState) {
        //添加光标样式
        L.DomUtil.addClass(this.map._container, 'leaflet-cursor-ranging');
      } else {
        //删除光标样式
        L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-ranging');
        // 清除所有测距相关操作
        this.clearAllRangingData();
      }
    },
    /**
     * MAPCJ02
     * 测距点击事件
     * @param latlng 点击坐标
     */
    clickRangingState (latlng) {
      const id = Date.now();
      const lineId = this.rangingIndex; // 当前线的唯一标识
      // 创建点
      const marker = L.marker(latlng, {
        id,
        lineId, // 将线的唯一标识存储在标记点中
        draggable: true, // 设置为可拖拽
        icon: L.divIcon({
          className: 'custom-marker', // 自定义 CSS 类
          html: '<div style="background-color: #fff; width: 10px; height: 10px; border-radius: 50%; border: 2px solid red;"></div>',
          iconSize: [14, 14], // 图标大小
          iconAnchor: [5, 5]
        })
      });
      // 初始化当前索引的数据结构（如果不存在）
      if (!this.rangingData[lineId]) {
        this.rangingData[lineId] = {
          marker: new Map(), // 存储标记点
          line: null // 存储线对象
        };
      }
      // 添加标记点到地图
      marker.addTo(this.map);
      this.rangingData[lineId].marker.set(id, marker);
      // 绑定悬浮提示
      marker.bindTooltip('单击删除此点，拖拽可移动位置', {
        permanent: false, // 提示不常驻显示
        direction: 'top', // 提示显示在标记点上方
        opacity: 0.9 // 提示透明度
      });
      // 更新线的坐标
      this.updateMeasureLine(lineId);
      // 监听点的拖拽事件
      marker.on('drag', () => {
        // 拖拽过程中，实时更新线的坐标
        this.updateMeasureLine(lineId);
        // 如果当前点是最后一个点，更新 "x" 按钮的位置
        if (this.isLastMarker(marker, lineId)) {
          this.updateCancelMarkerPosition(lineId, marker.getLatLng());
        }
      });
      // 监听点的点击事件（删除点）
      marker.on('click', () => {
        this.deleteMarkerAndupdateMeasureLine(marker, lineId);
      });
      // 如果当前线的标记点数量大于 1，更新最后一个点的 "x" 按钮
      if (this.rangingData[lineId].marker.size > 1) {
        this.updateCancelButton(lineId);
      }

    },
    /**
      * MAPCJ03
      * 判断当前点是否是最后一个点
      * @param marker 当前点
      * @param lineId 线的唯一标识
      * @returns {boolean} 是否是最后一个点
      */
    isLastMarker (marker, lineId) {
      const markers = Array.from(this.rangingData[lineId].marker.values());
      const lastMarker = markers[markers.length - 1];
      return marker === lastMarker;
    },
    /**
     * MAPCJ04
     * 更新 "x" 按钮的位置
     * @param lineId 线的唯一标识
     * @param latlng 新的位置坐标
     */
    updateCancelMarkerPosition (lineId, latlng) {
      const lineData = this.rangingData[lineId];
      if (!lineData || !lineData.cancelMarker) return;
      // 更新 "x" 按钮的位置
      lineData.cancelMarker.setLatLng(latlng);
    },
    /**
     * MAPCJ05
     * 更新最后一个点的 "x" 按钮
     * @param lineId 线的唯一标识
     */
    updateCancelButton (lineId) {
      const lineData = this.rangingData[lineId];
      if (!lineData) return;

      // 移除之前的 "x" 按钮（如果存在）
      if (lineData.cancelMarker) {
        lineData.cancelMarker.removeFrom(this.map);
        lineData.cancelMarker = null;
      }
      // 获取当前线的最后一个点
      const markers = Array.from(lineData.marker.values());
      const lastMarker = markers[markers.length - 1];
      // 在最后一个点上添加 "x" 按钮
      const cancelButton = L.divIcon({
        className: 'cancel-button', // 自定义 CSS 类
        html: '<div style="background-color: #fff; width: 13px; height: 13px; border: 2px solid red; display: flex; align-items: center; justify-content: center; font-size: 12px; color: red;">x</div>',
        iconSize: [20, 20], // 图标大小
        iconAnchor: [0, 30]
      });
      // 创建 "x" 按钮的标记点
      const cancelMarker = L.marker(lastMarker.getLatLng(), {
        icon: cancelButton,
        zIndexOffset: 1000 // 确保按钮显示在最上层
      }).addTo(this.map);
      // 监听 "x" 按钮的点击事件
      cancelMarker.on('click', () => {
        this.deleteRanginLine(lineId);
      });
      // 存储当前线的 "x" 按钮标记点
      lineData.cancelMarker = cancelMarker;
    },
    /**
     * MAPCJ06
     * 删除指定线的所有标记点和线
     * @param lineId 线的唯一标识
     */
    deleteRanginLine (lineId) {
      const lineData = this.rangingData[lineId];
      if (!lineData) return;
      // 移除线
      if (lineData.line) {
        lineData.line.removeFrom(this.map); // 从地图中移除线
        lineData.line = null; // 清空线对象
      }
      // 移除所有标记点
      if (lineData.marker) {
        lineData.marker.forEach((marker) => {
          marker.removeFrom(this.map); // 从地图中移除标记点
        });
        lineData.marker.clear(); // 清空标记点集合
      }
      // 移除 "x" 按钮
      if (lineData.cancelMarker) {
        lineData.cancelMarker.removeFrom(this.map);
        lineData.cancelMarker = null;
      }
      // 从 rangingData 中移除该线的数据
      delete this.rangingData[lineId];
    },
    /**
     * MAPCJ07
     * 删除标记点并更新线
     * @param marker 要删除的标记点
     * @param lineId 线的唯一标识
     */
    deleteMarkerAndupdateMeasureLine (marker, lineId) {
      if (!this.rangingData[lineId]) return;
      // 判断删除的点是否是最后一个点
      const isLastMarker = this.isLastMarker(marker, lineId);
      // 从地图中移除标记点
      marker.removeFrom(this.map);
      // 从数据结构中移除标记点
      this.rangingData[lineId].marker.delete(marker.options.id);
      // 更新线的坐标
      this.updateMeasureLine(lineId);
      // 如果线的顶点数量少于 2 个，则移除线并清除所有标记点
      if (this.rangingData[lineId].marker.size < 2) {
        if (this.rangingData[lineId].line) {
          this.rangingData[lineId].line.removeFrom(this.map); // 从地图中移除线
          this.rangingData[lineId].line = null; // 清空线对象
        }
        // 移除 "x" 按钮
        if (this.rangingData[lineId].cancelMarker) {
          this.rangingData[lineId].cancelMarker.removeFrom(this.map);
          this.rangingData[lineId].cancelMarker = null;
        }
        // 清除所有标记点
        this.rangingData[lineId].marker.forEach((marker) => {
          marker.removeFrom(this.map); // 从地图中移除标记点
        });
        this.rangingData[lineId].marker.clear(); // 清空标记点集合
      } else if (isLastMarker) {
        // 如果删除的点是最后一个点，且线的顶点数量仍然大于等于 2，则将 "x" 按钮移动到新的最后一个点上
        this.updateCancelButton(lineId);
      }
    },
    /**
     * MAPCJ08
     * 更新指定索引对应的线
     * @param lineId 线的唯一标识
     */
    updateMeasureLine (lineId) {
      if (!this.rangingData[lineId]) return;
      const markers = this.rangingData[lineId].marker;
      const lineCoordinates = [];
      // 获取所有标记点的坐标
      markers.forEach((marker) => {
        lineCoordinates.push(marker.getLatLng());
      });
      // 如果线不存在，则创建；否则更新
      if (!this.rangingData[lineId].line) {
        this.rangingData[lineId].line = L.polyline(lineCoordinates, {
          color: 'red', // 设置线颜色
          showMeasurements: true, // 显示测量值
          measurementOptions: {
            formatDistance: function (val) {
              // 测量值保留两位小数
              return val.toFixed(2) + 'm';
            }
          }
        }).addTo(this.map);
      } else {
        this.rangingData[lineId].line.setLatLngs(lineCoordinates);
      }
    },
    /**
     * MAPCJ09
     * 清除所有测距相关操作
     */
    clearAllRangingData () {
      // 遍历所有线
      this.rangingData.forEach((data, lineId) => {
        // 移除线
        if (data.line) {
          data.line.removeFrom(this.map); // 从地图中移除线
          data.line = null; // 清空线对象
        }

        // 移除所有标记点
        if (data.marker) {
          data.marker.forEach((marker) => {
            marker.removeFrom(this.map); // 从地图中移除标记点
          });
          data.marker.clear(); // 清空标记点集合
        }
        // 移除 "x" 按钮
        if (data.cancelMarker) {
          data.cancelMarker.removeFrom(this.map);
          data.cancelMarker = null;
        }
      });

      // 重置 rangingData 和 rangingIndex
      this.rangingData = [];
      this.rangingIndex = 0;
    },

    /**
     * MAPCJ10
     * 测距右击事件 终止连接操作
     */
    contextmenuRangingState () {
      this.rangingIndex += 1; // 增加索引，准备创建新的线
      this.rangingState = false;
      //删除光标样式
      L.DomUtil.removeClass(this.map._container, 'leaflet-cursor-ranging');
    },
    /**Popup弹框事件 Pup*/
    /**
     * Pup01
     * 添加管点Popup信息框
     * @param point 点对象
     */
    createMarkerPopup (point) {
      const attrList = Array.isArray(point.attributeNameValueList) ? point.attributeNameValueList : [];
      const attrRaw = (name) => {
        const row = attrList.find((item) => item.attributeName === name);
        const v = row && row.attributeValue;
        return v != null && v !== '' ? v : null;
      };
      const optionalAttrRow = (label, name) => {
        const v = attrRaw(name);
        return v != null ? `<p><span class="label">${label}:</span> <span>${v}</span></p>` : '';
      };
      const attrVal = (name) => {
        const v = attrRaw(name);
        return v != null ? v : '--';
      };
      const popup = L.popup({
        keepInView: true,//是否关闭页面同时关闭弹窗
        closeButton: false,//是否显示关闭按钮
      }).setContent(`
        <div class="point-popup">
          <p><span class="label">物探点号:</span> <span>${point.intuitionPoint || '--'}</span></p>
          ${optionalAttrRow('特征点', '特征点')}
          ${optionalAttrRow('附属物', '附属物')}
          ${optionalAttrRow('构筑物', '构筑物')}
          <p><span class="label">X坐标:</span> <span>${point.measurementLongitude ?
          (point.measurementLongitude.includes('.') ?
            point.measurementLongitude.substring(0, point.measurementLongitude.indexOf('.') + 3) :
            point.measurementLongitude) :
          '--'}</span></p>
          <p><span class="label">Y坐标:</span> <span>${point.measurementLatitude ?
          (point.measurementLongitude.includes('.') ?
            point.measurementLatitude.substring(0, point.measurementLatitude.indexOf(".") + 3) :
            point.measurementLatitude) :
          '--'}</span></p>
          <p><span class="label">Z高程:</span> <span>${point.groundElevation || '--'}</span></p>
          <p><span class="label">口径:</span> <span>${attrVal('口径')}</span></p>
          <p><span class="label">材质:</span> <span>${attrVal('材质')}</span></p>
        </div>
      `)
      // 阻止右键菜单
      popup.on('add', function () {
        const popupContent = this.getElement();
        if (popupContent) {
          popupContent.addEventListener('contextmenu', function (e) {
            e.preventDefault();
          });
        }
      });

      return popup;
    },
    /**
     * Pup02
     * 添加管线Popup信息框
     * @param line 点对象
     */
    createLinePopup (line, latlng) {
      const popup = L.popup({
        keepInView: true,//是否关闭页面同时关闭弹窗
        closeButton: false,//是否显示关闭按钮
      })
        .setLatLng(latlng)
        .setContent(`
    <div class="line-popup">
      <p><span class="label">连接点号:</span> <span>${line.connectionPointNumber || '--'}</span></p>
      <p><span class="label">被连接点号:</span> <span>${line.theDotNumberIsConnected || '--'}</span></p>
      <p><span class="label">连接点埋深:</span> <span>${line.connectionPointDeep || '--'}</span></p>
      <p><span class="label">被连接点埋深:</span> <span>${line.theDotNumberIsDeep || '--'}</span></p>
      <p><span class="label">管材:</span> <span>${line.attributeNameValueList.find(item => item.attributeName === "管材")?.attributeValue || '--'}</span></p>
      <p><span class="label">管径:</span> <span>${line.attributeNameValueList.find(item => item.attributeName === "管径")?.attributeValue || '--'}</span></p>
      <p><span class="label">压力:</span> <span>${line.attributeNameValueList.find(item => item.attributeName === "压力")?.attributeValue || '--'}</span></p>
      <p><span class="label">埋设方式:</span> <span>${line.attributeNameValueList.find(item => item.attributeName === "埋设方式")?.attributeValue || '--'}</span></p>
    </div>
      `)
      // 阻止右键菜单
      popup.on('add', function () {
        const popupContent = this.getElement();
        if (popupContent) {
          popupContent.addEventListener('contextmenu', function (e) {
            e.preventDefault();
          });
        }
      });

      return popup;
    },
    /**
     * Pup03
     * 添加右键点击
     * @param obj 选中对象 管点 OR 管线
     * @param type 选中类型 管点 OR 管线
     * @param latlng 点击坐标
     */
    createEditorPopup (obj, type, latlng) {
      // 创建新的弹窗
      const popup = L.popup({
        keepInView: true, // 是否关闭页面同时关闭弹窗
        closeButton: false, // 是否显示关闭按钮
      })
        .setLatLng(latlng)
        .setContent(`
      <div class="editor-popup">
        <ul>
          <li data-action="edit"><img src="${this.updateImg}"/>${type == 'line' ? '编辑管线' : '编辑管点'}</li>
          <li data-action="coordinate"><img src="${this.coordinateImg}"/>${type == 'line' ? '插入管点' : '坐标编辑'}</li>
          ${type !== 'line' ? `<li data-action="move"><img src="${this.moveImg}"/>移动管点</li>` : ''}
          <li data-action="delete"><img src="${this.deleteImg}"/>${type == 'line' ? '删除管线' : '删除管点'}</li>
        </ul>
      </div>
    `);

      // 添加编辑菜单点击事件
      popup.on('add', () => {
        const popupElement = popup.getElement();
        if (popupElement) {
          popupElement.addEventListener('contextmenu', function (e) {
            e.preventDefault();
          });
          // 使用事件委托，将点击事件绑定到 ul 元素
          const ul = popupElement.querySelector('ul');
          if (ul) {
            ul.addEventListener('click', (event) => {
              const li = event.target.closest('li');
              if (li) {
                const action = li.getAttribute('data-action');
                switch (action) {
                  case 'edit': //'编辑管线' : '编辑管点' 操作
                    console.log(`editorPopup编辑${type}被点击`);
                    this.editPopup(obj, type);
                    break;
                  case 'coordinate': //'插入管点' : '坐标编辑' 操作
                    console.log(`coordinatePopup编辑${type}被点击`);
                    this.coordinatePopup(obj, type, latlng);
                    break;
                  case 'move': //'移动管点' 操作
                    this.movePopupShow(obj, type);
                    break;
                  case 'delete': //'删除管线' : '删除管点' 操作
                    console.log(`deletePopup编辑${type}被点击`);
                    this.deletePopup(obj, type);
                    break;
                  default:
                    console.warn('未知操作:', action);
                }
              }
            });
          }
        }
      });
      return popup;
    },
    /**
     * Pup03
     * 右击地图监听循环查询获取点位信息 修改弹框显示
     * @param latlng 坐标
     */
    queryMarkerPopup (latlng, type) {
      //获取点击的key
      let key = this.coordinateIndex(latlng);
      //如果key不为null 则查询map对象中的key
      if (key) {
        //获取当前右键对象
        let marker = this.markerMap.get(key);
        switch (type) {
          case 'info':
            let popupInfo = this.createMarkerPopup(marker.options.element);
            marker.bindPopup(popupInfo).openPopup();
            break;
          case 'editor':
            let popupEditor = this.createEditorPopup(marker, 'marker', latlng);
            marker.bindPopup(popupEditor).openPopup();
            break;
        }
      }
    },
    /**
     * Pup03创建删除框
     */
    createDelPopup (latlng, type, data) {
      // 创建新的弹窗
      const popup = L.popup({
        keepInView: true, // 是否关闭页面同时关闭弹窗
        closeButton: false, // 是否显示关闭按钮
      })
        .setLatLng(latlng)
        .setContent(`
      <div class="del-popup">
         <div class="del-popup-content">
          <p> 确定要删除 
            <span class="del-item-name">
              ${type == 'line' ? data.connectionPointNumber + '-' + data.theDotNumberIsConnected : data.intuitionPoint}
            </span> 吗？
          </p>
          <div class="del-popup-buttons">
            <button id="delete-button" class="del-popup-button">删除</button>
            <button id="cancel-button" class="cancel-popup-button">取消</button>
          </div>
        </div>
      </div>
      </div>
    `);
      popup.on('add', () => {
        const popupElement = popup.getElement();
        if (popupElement) {
          popupElement.addEventListener('contextmenu', function (e) {
            e.preventDefault();
          });
          // 获取删除按钮
          const deleteButton = popupElement.querySelector('#delete-button');
          // 获取取消按钮
          const cancelButton = popupElement.querySelector('#cancel-button');

          // 监听删除按钮点击事件
          deleteButton.addEventListener('click', () => {
            console.log('删除按钮被点击');
            this.deleteMarkerORLine(data, type);
            // 在这里执行删除逻辑
            popup.remove(); // 关闭弹窗
          });

          // 监听取消按钮点击事件
          cancelButton.addEventListener('click', () => {
            console.log('取消按钮被点击');
            popup.remove(); // 关闭弹窗
          });
        }
      })

      return popup;
    },
    /**
     * Pup-Update
     * 编辑操作 '编辑管线' : '编辑管点' 操作
     * @param obj 右键对象
     * @param type 类型
     */
    editPopup (obj, type) {
      console.log(obj);

      if (obj.options.element.tubeClassCode != this.projectData.tubeClassCode) { this.$message.warning('请将类型设置同一管类'); return; }
      switch (type) {
        case 'marker':
          this.formController('marker', '编辑管点', this.markerPropList, obj.options.element);
          obj.closePopup();
          break;
        case 'line':
          this.formController('line', '编辑管线', this.linePropList, obj.options.element);
          this.currentPopup.close();
          break;
      }
    },
    /**
     * Pup-Extra
     * 编辑操作 '插入管点' : '坐标编辑' 操作
     * @param obj 右键对象
     * @param type 类型
     */
    coordinatePopup (obj, type, latlng) {
      switch (type) {
        case 'marker':
          //坐标编辑框赋值
          //先隐藏其他框
          this.hideModule();
          this.coordinateShow = true;
          this.coordinateEditorData = obj.options.element
          obj.closePopup();
          break;
        case 'line':
          this.addTemporaryData(latlng);
          this.currentLine = obj; //获取当前操作线
          obj.latlng = latlng;
          this.formController('marker', '插入管点', this.markerPropList, obj);
          this.currentPopup.close();
          break;
      }
    },
    /**
     * Pup-Del
     * 编辑操作 '删除管点' : '删除管线' 操作
     * @param obj 右键对象
     * @param type 类型
     */
    deletePopup (obj, type) {
      switch (type) {
        case 'marker':
          obj.closePopup();
          let popupInfoMarker = this.createDelPopup(obj.getLatLng, type, obj.options.element);
          obj.bindPopup(popupInfoMarker).openPopup();
          break;
        case 'line':
          let popupInfoLine = this.createDelPopup(this.currentPopup.getLatLng(), type, obj.options.element);
          this.currentPopup.close();
          obj.bindPopup(popupInfoLine).openPopup();
          break;
      }
    },
    /**
     * Pup-MoveShow
     * 编辑操作 '移动管点' 操作
     * @param obj 右键对象
     * @param type 类型
     */
    movePopupShow (obj, type) {
      obj.closePopup();
      //获取当前管点
      this.currentMarker = obj;
      //开启编辑移动管点
      this.moveShow = true;
    },
    /**
     * Pup-Move
     * 移动管点Popup框
     * @param obj 右键对象
     * @param latlng 移动位置
     */
    movePopup (obj, latlng) {
      //复用删除框样式
      const popup = L.popup({
        keepInView: true, // 是否关闭页面同时关闭弹窗
        closeButton: false, // 是否显示关闭按钮
      })
        .setContent(`
      <div class="del-popup">
         <div class="del-popup-content">
          <p> 确定要移动 
            <span class="del-item-name">
              ${this.currentMarker.options.element.intuitionPoint}
            </span> 吗？
          </p>
          <div class="del-popup-buttons">
            <button id="delete-button" class="move-popup-button">移动</button>
            <button id="cancel-button" class="cancel-popup-button">取消</button>
          </div>
        </div>
      </div>
      </div>
    `);
      popup.on('add', () => {
        const popupElement = popup.getElement();
        if (popupElement) {
          popupElement.addEventListener('contextmenu', function (e) {
            e.preventDefault();
          });
          // 获取移动按钮
          const moveButton = popupElement.querySelector('#delete-button');
          // 获取取消按钮
          const cancelButton = popupElement.querySelector('#cancel-button');

          // 监听删除按钮点击事件
          moveButton.addEventListener('click', () => {
            console.log(this.currentMarker);

            console.log('移动按钮被点击');
            let parameter = {
              id: this.currentMarker.options.element.id,
              obscureLongitude: latlng.lng,
              obscureLatitude: latlng.lat
            }
            this.moveMarkerApi(parameter, 'move');
            // 在这里执行删除逻辑
            this.delTemporaryData();
          });

          // 监听取消按钮点击事件
          cancelButton.addEventListener('click', () => {
            console.log('取消按钮被点击');
            this.delTemporaryData();
          });
        }
      })
      obj.bindPopup(popup).openPopup();
    },
    /**
     * Pup-CAll
     * 彻底删除所有Popup
     */
    clearAllPopups () {
      this.markerMap.forEach((item, key) => {
        // 关闭 Popup
        if (item.isPopupOpen()) {
          item.closePopup();
        }
        // 移除 Popup
        if (item.getPopup()) {
          item.unbindPopup(); // 解除 Popup 绑定
        }
      })
      if (this.currentPopup) {
        this.currentPopup.close(); // 关闭 Popup
        this.currentPopup.remove(); // 从地图上移除 Popup
        this.currentPopup = null; // 清空引用
      }

    },
    /**图层控制显示 MAPXS */
    /**
     * MAPXS01
     * @param data 显示数据
     * @param type 显示类型
     */
    showHighlightData (data, type) {
      let list = null
      switch (type) {
        case 1: //类型为1则为管点
          list = {
            marker: this.showMarkerHighlight(data)
          }
          break;
        case 2: //类型为2则为管线
          list = {
            line: this.showLineHighlight(data)
          }
          break;
        case 3:
          list = {
            marker: this.showMarkerHighlight(data.pipePointInfoPcList),
            line: this.showLineHighlight(data.pipelineInfoPcList),
          }
          break;
        default:
          break;
      }
      this.highlightData = {
        data: list,
        type
      }
    },
    /**
     * MAPXS02
     * 显示管点高亮
     * @param data 显示数据
     */
    showMarkerHighlight (data) {
      let map = new Map();
      data.forEach(item => {
        //获取点位图标
        let pointInfo = this.icon.highlight.compare;
        //创建点位坐标
        let latlngArray = [item.cgCsLatitude, item.cgCsLongitude];
        //创建 markerIcon icon 点位图标对象
        let markerIcon = L.icon({ iconUrl: pointInfo.iconUrl, iconSize: pointInfo.iconSize, iconAnchor: [5, 6] });
        //创建 marker 项目点位数据
        let marker = L.marker(latlngArray, { icon: markerIcon });
        //添加进canvas图层对象
        this.mapCanvas.addLayer(marker);
        map.set(item.intuitionPoint, marker);
      })
      return map;
    },
    /**
     * MAPXS03
     * 显示管线高亮
     * @param data 显示数据
     */
    showLineHighlight (data) {
      let map = new Map();
      data.forEach(item => {
        //创建线坐标
        let latlngArray = item.beginLatitude == null ?
          [this.markerMap.get(item.connectionPointNumber).getLatLng(), this.markerMap.get(item.theDotNumberIsConnected).getLatLng()] :
          [[item.beginLatitude, item.beginLongitude], [item.endLatitude, item.endLongitude]];
        //创建线
        let options = {
          ...this.lineStyle.checked,
        }
        let polyline = L.polyline(latlngArray, options).addTo(this.map);
        map.set(item.id, polyline)
      })
      return map;
    },
    /**
     * MAPXS04
     * 删除高亮点与其相关联线
     */
    clearHighlightMAndL (key, data) {
      // 确保 highlightData 和其属性存在
      if (!this.highlightData || !this.highlightData.data || !this.highlightData.data.marker) {
        console.warn('highlightData 数据无效');
        return;
      }
      // 删除高亮点
      const marker = this.highlightData.data.marker.get(key);
      if (marker) {
        this.highlightData.data.marker.delete(key);
        this.mapCanvas.removeLayer(marker);
      } else {
        console.warn(`未找到 key 为 ${key} 的高亮点`);
      }
      // 删除相关联的高亮线
      if (data && data.length > 0) {
        for (const item of data) {
          this.clearHighlightLine(item.id);
        }
      }
    },
    /**
     * MAPXS0
     * 删除高亮线
     */
    clearHighlightLine (key) {
      // 确保 highlightData 和其属性存在
      if (!this.highlightData || !this.highlightData.data || !this.highlightData.data.line) {
        console.warn('highlightData 数据无效');
        return;
      }
      // 删除高亮线
      const line = this.highlightData.data.line.get(key);
      if (line) {
        line.remove();
        this.highlightData.data.line.delete(key);
      } else {
        console.warn(`未找到 key 为 ${key} 的高亮线`);
      }
    },
    /**
     * MAPXS-GLQC
     * 清除高亮显示
     */
    clearAwayHighlight () {
      let highlightData = this.highlightData
      console.log(highlightData.data);

      if (highlightData.length != 0) {
        switch (highlightData.type) {
          case 1: //清除高亮点
            highlightData.data.marker.forEach(item => {
              this.mapCanvas.removeLayer(item);
            })
            break;
          case 2: //清除高亮线
            highlightData.data.line.forEach(item => {
              item.remove();
            })
            break;
          case 3: //清除所有高亮点,线
            highlightData.data.marker.forEach(item => {
              this.mapCanvas.removeLayer(item);
            })
            highlightData.data.line.forEach(item => {
              item.remove();
            })
            break;
          default:
            break;
        }
      }
      this.highlightData = {};
    },
    /**图层基础要素配置事件 MAPYS */
    /**
      * MAPYS01
      * 初始化icon对象
      */
    initializeIcon () {
      this.icon = {
        // 默认点图标
        point: this.createIconPair('point.png', 'point-cmp.png', [12, 12], 'point'), //无特殊图标点位
        // 高亮图标
        highlight: this.createIconPair('highlight.png', 'highlight.png', [12, 12], 'highlight'),
        // 其他图标类型
        valve: this.createIconPair('valve.png', 'valve-cmp.png', [10, 15], 'valve'), //阀门
        waterMeter: this.createIconPair('water-meter.png', 'water-meter-cmp.png', [12, 12], 'waterMeter'), //水表
        fireHydrant: this.createIconPair('fire-hydrant.png', 'fire-hydrant-cmp.png', [10, 15], 'fireHydrant'), //消防栓
        drainValve: this.createIconPair('drain-valve.png', 'drain-valve-cmp.png', [10, 15], 'drainValve'), //排水阀
        ventValve: this.createIconPair('vent-valve.png', 'vent-valve-cmp.png', [10, 15], 'ventValve'), //排气阀
        pressurePump: this.createIconPair('pressure-pump.png', 'pressure-pump-cmp.png', [18, 12], 'pressurePump'), //加压泵站
        valveChamber: this.createIconPair('valve-chamber.png', 'valve-chamber-cmp.png', [12, 12], 'valveChamber'), //阀门井
        wmChamber: this.createIconPair('wm-chamber.png', 'wm-chamber-cmp.png', [18, 12], 'wmChamber'), //水表井
        fireShaft: this.createIconPair('fire-shaft.png', 'fire-shaft-cmp.png', [12, 12], 'fireShaft'), //消防井
        flowmeter: this.createIconPair('flowmeter.png', 'flowmeter-cmp.png', [18, 12], 'flowmeter'), //流量计
        pressureGage: this.createIconPair('pressure-gage.png', 'pressure-gage-cmp.png', [12, 15], 'pressureGage'), //压力表
        checkValve: this.createIconPair('check-valve.png', 'check-valve-cmp.png', [18, 12], 'checkValve'), //止回阀
        reliefValve: this.createIconPair('relief-valve.png', 'relief-valve-cmp.png', [18, 12], 'reliefValve'),  //减压阀
        expansionPiece: this.createIconPair('expansion-piece.png', 'expansion-piece-cmp.png', [18, 12], 'expansionPiece'), //伸缩器
        manhole: this.createIconPair('manhole.png', 'manhole-cmp.png', [18, 12], 'manhole'), //检修井
        pool: this.createIconPair('pool.png', 'pool-cmp.png', [12, 12], 'pool'), //水池
        waterTank: this.createIconPair('water-tank.png', 'water-tank-cmp.png', [12, 12], 'waterTank'), //水箱
        waterTower: this.createIconPair('water-tower.png', 'water-tower-cmp.png', [12, 12], 'waterTower'), //水塔
        localpoint: { iconUrl: require(`@/assets/collect/localpoint3.png`), iconSize: [20, 20], type: 'localpoint' }, // 定位点图标
        pointcheck: { iconUrl: require(`@/assets/collect/pointcheck-cmp.png`), iconSize: [21, 30], iconAnchor: [10, 30], type: 'pointcheck' }, // 点击后点图标
        arrow: { iconUrl: require(`@/assets/collect/new_arrow.png`), iconSize: [10, 10], iconAnchor: [5, 0], type: 'arrow' }, //流向图标
        ranging: { iconUrl: require(`@/assets/collect/ranging_point.png`), iconSize: [12, 12], type: 'ranging' } //测距点图标
      }
    },
    /**
      * MAPYS02
      * 初始化icon对象
      * @param normalIcon 图标名称
      * @param cmpIcon 收点后图标名称
      * @param size 图标大小
      * @param type 图标类型
      */
    createIconPair (normalIcon, cmpIcon, size, type) {
      return {
        normal: {
          iconUrl: require('@/assets/collect/' + normalIcon),
          iconSize: size,
          type: type
        },
        compare: {
          iconUrl: require('@/assets/collect/' + cmpIcon),
          iconSize: size,
          type: type
        }
      };
    },
    /**
     * MAPYS03
     * 判断图标icon对象获取对应对象
     * @param type 图标类型
     * @param closingPoints 图标状态 (是否收点)
     */
    judgeIcon (type, closingPoints) {
      // 创建一个类型到图标对象的映射
      const iconMap = {
        '阀门': 'valve',
        '水表': 'waterMeter',
        '消防栓': 'fireHydrant',
        '排水阀': 'drainValve',
        '排气阀': 'ventValve',
        '加压泵站': 'pressurePump',
        '阀门井': 'valveChamber',
        '水表井': 'wmChamber',
        '流量计': 'flowmeter',
        '压力表': 'pressureGage',
        '止回阀': 'checkValve',
        '消防井': 'fireShaft',
        '减压阀': 'reliefValve',
        '伸缩器': 'expansionPiece',
        '检修井': 'manhole',
        '消防阀门': 'valve',
        '水池': 'pool',
        '水箱': 'waterTank',
        '水塔': 'waterTower'
      };
      // 从映射中获取图标对象属性，如果不存在则使用默认属性 'point'
      const iconKey = iconMap[type] || 'point';
      // 从映射中获取图标对象类型，0为未收点 'normal'，其他为以收点 'compare'
      // PC端不显示收点信息
      const iconType = (closingPoints == 0 || closingPoints == null) ? 'normal' : 'normal'
      // 从 this.icon 中获取对应的图标对象，并根据 closingPoints 获取具体的图标
      const pointIcon = this.icon[iconKey][iconType];
      // 返回结果对象
      return {
        pointIcon
      };
    },

    /**工具栏事件区域 */

    /**
     * 计算中心点
     * @param latLngs 
     */
    calculateCenter (latLngs) {
      let latSum = 0;
      let lngSum = 0;
      const count = latLngs.length;

      // 遍历所有顶点，累加纬度和经度
      latLngs.forEach(point => {
        latSum += point.lat;
        lngSum += point.lng;
      });

      // 计算平均值
      const centerLat = latSum / count;
      const centerLng = lngSum / count;

      return [centerLat, centerLng]; // 返回中心点的经纬度数组
    },
    /**
     * 处理管线工具点击
     * @param type 工具类型
     */
    handlePipelineToolClick (type) {
      switch (type) {
        case 'batchEdit':
          // 批量修改
          this.$message.info('批量修改功能开发中...')
          break
        case 'dataCheck':
          // 数据查错
          this.$message.info('数据查错功能开发中...')
          break
        case 'statistics':
          // 信息统计
          this.$message.info('信息统计功能开发中...')
          break
        case 'insertProject':
          // 插入项目
          this.$message.info('插入项目功能开发中...')
          break
      }
    },

    /**
     * 处理辅助工具点击
     * @param type 工具类型
     */
    handleAssistToolClick (type) {
      switch (type) {
        case 'createSelection':
          // 创建管线选择集
          this.$message.info('创建管线选择集功能开发中...')
          break
        case 'pointMark':
          // 点号下划线标注
          this.intuitionPointLabelShow = !this.intuitionPointLabelShow
          break
        case 'heightMark':
          // 点高程下划线标注
          this.elevationLabelShow = !this.elevationLabelShow
          break
      }
    },

    /**
     * 切换底图
     * @param type 底图类型
     */
    handleBaseMapChange (type) {
      // 清除现有图层
      if (this.tileLayers.length > 0) {
        this.tileLayers.forEach(layer => {
          this.map.removeLayer(layer)
        })
        this.tileLayers = []
      }

      let baseLayer, annotationLayer

      switch (type) {
        case 'vector':
          // 矢量地图
          baseLayer = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', {
            key: '485cd3a62955d7a962a5c0d64d4949f2'
          })
          annotationLayer = L.tileLayer.chinaProvider('TianDiTu.Normal.Annotion', {
            key: '485cd3a62955d7a962a5c0d64d4949f2'
          })
          this.currentBaseMap = '矢量地图'
          break
        case 'Satellite':
          // 天地影像
          baseLayer = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
            key: '485cd3a62955d7a962a5c0d64d4949f2'
          })
          annotationLayer = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
            key: '485cd3a62955d7a962a5c0d64d4949f2'
          })
          this.currentBaseMap = '天地影像'
          break
      }

      // 添加新图层
      if (baseLayer) {
        baseLayer.addTo(this.map)
        this.tileLayers.push(baseLayer)
      }
      if (annotationLayer) {
        annotationLayer.addTo(this.map)
        this.tileLayers.push(annotationLayer)
      }
    },
    handleFilterSuccess (filterResult) {
      console.log(filterResult);

      //先清除现有高亮
      this.clearAwayHighlight();
      // 设置过滤类型
      this.filterType = filterResult.type === '管点' ? 1 : 2

      // 确保数据是数组
      const data = Array.isArray(filterResult.data) ? filterResult.data : []

      // 设置表格数据，使用数字类型的key
      this.filterDetailData = data.map((item, index) => ({
        ...item,
        key: index // 直接使用数字作为key
      }))
      // 高亮显示
      this.showHighlightData(filterResult.data, this.filterType);

      // 设置表格列配置
      let columns = [...filterResult.columns]
      // 添加操作列
      columns.push({
        title: '操作',
        key: 'action',
        width: 100,
        scopedSlots: { customRender: 'action' }
      })
      this.filterDetailColumns = columns

      // 显示过滤详情弹窗
      this.filterDetailVisible = true

      // 重置选中状态
      this.selectedDetailKeys = []

      // 获取模板列表
      this.getTemplateList()
    },
    closeFilterDetail () {
      this.filterDetailVisible = false
      this.filterDetailData = []
      this.selectedDetailKeys = []
      this.selectedTemplateId = undefined
      this.selectedTemplateType = null
    },
    onDetailSelectChange (selectedRowKeys) {
      this.selectedDetailKeys = selectedRowKeys
    },
    /**
     * 导入GIS系统
     */
    async handleImportGIS () {
      this.$message.success('功能梳理中...')
      // try {
      //   const res = await this.$http.post('/gis-manager/diagramming/project/import/gis', {
      //     projectManagementId: this.currentProjectId
      //   })
      //   if (res.code === 0) {
      //     this.$message.success('导入GIS系统成功')
      //   } else {
      //     this.$message.error(res.message || '导入GIS系统失败')
      //   }
      // } catch (error) {
      //   console.error('导入GIS系统失败:', error)
      //   this.$message.error('导入GIS系统失败')
      // }
    },
    async getTemplateList () {
      try {
        const res = await this.$http.get('/gis-manager/foundation/template/all/list', {
          params: {
            templateType: this.filterType || 1
          }
        })
        if (res.code === 0) {
          this.templateList = res.data || []
        } else {
          this.$message.error(res.message || '获取模板列表失败')
        }
      } catch (error) {
        console.error('获取模板列表失败:', error)
        this.$message.error('获取模板列表失败')
      }
    },
    handleTemplateChange (value) {
      const template = this.templateList.find(item => item.id === value)
      if (template) {
        this.selectedTemplateType = template.templateType
      }
    },
    async handleExportFilter () {
      if (!this.selectedTemplateId) {
        this.$message.error('请选择导出模板')
        return
      }

      if (this.selectedDetailKeys.length === 0) {
        this.$message.error('请选择要导出的数据')
        return
      }

      try {
        this.exportLoading = true
        // 获取选中项的id列表
        const idList = this.selectedDetailKeys.map(key => {
          const item = this.filterDetailData.find((_, index) => index === key)
          return Number(item.id)
        })
        let params = {
          ifPipeline: this.filterType,
          templateId: this.selectedTemplateId,
          projectManagementId: this.currentProjectId,
          idList: idList
        }
        const formData = new FormData()
        formData.append('exportFiltering', JSON.stringify(params))

        const url = `${process.env.VUE_APP_API_BASE_URL}gis-manager/diagramming/project/export/filtering`
        const head = this.$store.getters.token
        const res = await axios({
          method: 'post',
          url: url,
          data: formData,
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': head
          }
        })

        // 检查响应状态
        if (res.status === 200) {
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          })
          const fileName = '过滤数据导出.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
        } else {
          this.$message.error('导出失败')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    /**
     * 处理查看过滤详情项
     * @param record 记录对象
     */
    handleViewDetailItem (record) {
      // 根据过滤类型判断是管点还是管线
      if (this.filterType === 1) {
        // 管点 - 使用物探点号定位
        this.goToMarker(record.intuitionPoint)
      } else {
        // 管线 - 使用ID定位
        this.goToLine(record.id)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pipeline-mapping {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 999;
  background: #fff;

  .map {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
  }

  // 统一工具栏公共样式
  .toolbar-common {
    position: absolute;
    z-index: 1000;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    top: 10px;
    height: 48px;
    display: flex;
    align-items: center;
    caret-color: transparent;
    transition: all 0.3s ease-in-out;
  }

  .left-toolbar {
    left: 10px;
    padding: 0 8px;
    flex-direction: row;
  }

  .center-toolbar {
    left: 50%;
    transform: translateX(-50%);
  }

  .right-toolbar {
    right: 10px;
  }

  .tool-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 4px;

    &:hover {
      background: #f0f0f0;
      border-radius: 4px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .filter-detail-modal {
    position: fixed;
    right: 25px;
    bottom: 25px;
    width: 600px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;

    .filter-detail-header {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }

      .close-icon {
        cursor: pointer;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;

        &:hover {
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }


  }

  .filter-detail-content {
    padding: 16px;
    max-height: 400px;
    margin-bottom: 20px;

    .template-select {
      margin-bottom: 16px;
      display: flex;
      align-items: center;

      .label {
        margin-right: 8px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
      }
    }
  }
}


// 隐藏页脚
:global(.footer) {
  display: none !important;
}

// 确保容器占满整个视口且无滚动
:global(body),
:global(#app) {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

// 弹窗样式
/deep/ .point-popup {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  opacity: 0.8;
  background-color: #0a1924;
  padding: 15px;
  position: relative;
  border-radius: 12px;
  border: 1px solid #8291bd;

  p {
    display: flex;
    margin: 0 0 5px;
    /* 文字和内容分开对齐 */
  }

  .label {
    color: white;
    min-width: 60px;
    /* 调整以适应你的内容 */
    text-align: right;
    margin-right: 10px;
    /* 调整间距 */
  }

  p>span {
    color: #eac515;
  }
}

/deep/ .line-popup {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  opacity: 0.8;
  background-color: #0a1924;
  padding: 15px;
  position: relative;
  border-radius: 12px;
  border: 1px solid #8291bd;

  p {
    display: flex;
    margin: 0 0 5px;
    /* 文字和内容分开对齐 */
  }

  .label {
    color: white;
    min-width: 80px;
    /* 调整以适应你的内容 */
    text-align: right;
    margin-right: 10px;
    /* 调整间距 */
  }

  p>span {
    color: #eac515;
  }
}

/deep/ .line-popup::before {
  content: '';
  position: absolute;
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-width: 11px 11px 0 11px;
  border-style: solid;
  border-color: #8291bd transparent transparent transparent;
  z-index: -1;
}

/deep/ .line-popup::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  margin-left: -10px;
  border-width: 10px 10px 0 10px;
  border-style: solid;
  border-color: #0a1924 transparent transparent transparent;
}

/deep/ .point-popup::before {
  content: '';
  position: absolute;
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-width: 11px 11px 0 11px;
  border-style: solid;
  border-color: #8291bd transparent transparent transparent;
  z-index: -1;
}

/deep/ .point-popup::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  margin-left: -10px;
  border-width: 10px 10px 0 10px;
  border-style: solid;
  border-color: #0a1924 transparent transparent transparent;
}

//编辑框样式
/deep/ .editor-popup {
  background-color: white;
  border-radius: 5px;
  width: 125px;
  caret-color: transparent;

  img {
    width: 16px;
    height: 16px;
  }

  ul {
    list-style: none;
    /* 移除默认的列表样式 */
    padding: 0;
    /* 移除默认的内边距 */
    margin: 0;

    /* 移除默认的外边距 */
    li {
      display: flex;
      /* 使用 Flexbox 布局 */
      // align-items: center;
      /* 垂直居中对齐 */
      gap: 12px;
      /* 图片和文字之间的间距 */
      padding: 8px 12px;
      /* 调整列表项的上下内边距 */
    }
  }

  ul li:hover {
    background-color: #e5f5ff;
    /* 悬浮时的背景色 */
  }
}


/deep/ .editor-popup::after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -10px;
  /* 三角形宽度的一半，负值以使其居中 */
  border-width: 10px 10px 0 10px;
  /* 上边框宽度决定三角形高度，左右边框宽度决定三角形底边宽度 */
  border-style: solid;
  border-color: white transparent transparent transparent;
  /* 上边框颜色与背景色相同，其余边框透明 */
}

/deep/ .leaflet-popup-content-wrapper,
/deep/ .leaflet-popup-tip {
  background: none;
}

/deep/ .leaflet-popup-content {
  margin: 0;
}



// 表单样式
/* 原有样式 */
.module {
  z-index: 1000;
  background-color: white;
  position: absolute;
  left: 10px;
  top: 75px;
  border-radius: 4px;
  width: 255px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* 添加边框阴影 */
}



// 进入(显示)开始时和离开(隐藏)结束时效果
.first-enter,
.first-leave-to {
  opacity: 0;
}

// 进入(显示)过程中和离开(隐藏)过程中的效果
.first-enter-active,
.first-leave-active {
  // 设置过渡持续时间
  transition: all 0.5s;
}

.coordinateEditor {
  margin: 0;
}

//leaflet-draw样式
/deep/ .leaflet-div-icon {
  width: 10px !important;
  height: 10px !important;
  background-color: red;
  margin-left: -5px !important;
  margin-top: -5px !important;
  border-radius: 50%;
}


.leaflet-cursor-ranging {
  cursor: url('../../assets/collect/rangings.svg'), auto
}

.leaflet-cursor-surface {
  cursor: url('../../assets/collect/surfaces.svg'), auto
}

.leaflet-cursor-get {
  cursor: url('../../assets/collect/getCoordinate.svg'), auto
}

.leaflet-cursor-get2 {
  cursor: url('../../assets/collect/getCoordinate.svg'), auto
}



/**删除框样式 */
/deep/ .del-popup {
  width: 200px;
}

/deep/ .del-popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/deep/ .del-popup-content p {
  margin: 0 0 20px;
  font-size: 12px;
}

/deep/ .del-item-name {
  font-weight: bold;
  color: #f00;
}

/deep/ .del-popup-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/deep/.del-popup-button {
  background-color: #ff4d4f;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/deep/ .move-popup-button {
  background-color: #54e25e;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/deep/.del-popup-button:hover {
  background-color: #ff7875;
}


/deep/ .cancel-popup-button {
  background-color: #f0f0f0;
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/deep/.cancel-popup-button:hover {
  background-color: #d9d9d9;
}

/**移动框样式 */

//加载遮罩层
/deep/ .ant-spin-nested-loading {
  height: 100%;
  z-index: 999;
}

/deep/ .ant-spin-blur {
  height: 100%;
}

/deep/.ant-spin-nested-loading>div>.ant-spin {
  max-height: none;
}



/deep/ .line-container {
  position: relative;
  width: 200px;
  /* 整体宽度 */
  margin-top: 30px;
  /* 为文字留出空间 */
}

/deep/ .slanted-line {
  width: 1.5px;
  /* 斜线的粗细 */
  height: 15px;
  /* 斜线的高度 */
  background-color: #00ff12;
  /* 斜线的颜色 */
  transform: rotate(45deg);
  /* 旋转45度实现斜线效果 */
  transform-origin: top left;
  /* 以左上角为中心旋转 */
  position: absolute;
  top: 0;
  left: 0;
}

/deep/ .straight-line {
  width: 75px;
  /* 直线的长度 */
  height: 2px;
  /* 直线的粗细 */
  // background-color: #00ff12;
  border-top: 2px dashed #00ff12;
  /* 直线的颜色 */
  position: absolute;
  top: 0;
  /* 直线与斜线的顶部对齐 */
  // left: 15px;
  /* 调整直线与斜线的连接位置 */
}

/deep/ .divIcon-text {
  position: absolute;
  top: -22px;
  /* 文字距离斜线的垂直距离 */
  left: 0;
  /* 文字水平位置 */
  font-size: 12px;
  padding: 1px 5px;
  border-radius: 4px;
  /* 文字大小 */
  color: white;
  background-color: rgba(7, 155, 20, 0.7);
  /* 文字颜色 */
  white-space: nowrap;
  /* 防止文字换行 */
}



/deep/ .line-container-gc {
  position: relative;
  width: 200px;
  /* 整体宽度 */
  margin-top: 30px;
  /* 为文字留出空间 */
}

/deep/ .slanted-line-gc {
  width: 1.5px;
  /* 斜线的粗细 */
  height: 15px;
  /* 斜线的高度 */
  background-color: #04bde2;
  /* 斜线的颜色 */
  transform: rotate(-45deg);
  /* 旋转-45度实现斜线效果 */
  transform-origin: top right;
  /* 以右上角为中心旋转 */
  position: absolute;
  top: 0;
  right: 0;
  /* 斜线从右侧开始 */
}

/deep/ .straight-line-gc {
  width: 70px;
  /* 直线的长度 */
  height: 2px;
  /* 直线的粗细 */
  // background-color: #04bde2;
  border-top: 2px dashed #04bde2;
  /* 虚线样式 */
  /* 直线的颜色 */
  position: absolute;
  top: 0;
  /* 直线与斜线的顶部对齐 */
  right: 0px;
  /* 调整直线与斜线的连接位置 */
}

/deep/ .divIcon-text-gc {
  position: absolute;
  top: -22px;
  padding: 1px 5px;
  /* 文字距离斜线的垂直距离 */
  right: 0;
  /* 文字水平位置 */
  font-size: 12px;
  background-color: rgba(23, 135, 255, 0.7);
  /* 文字大小 */
  color: white;
  /* 文字颜色 */
  white-space: nowrap;
  /* 防止文字换行 */
}
</style>
